import React, { useState, useEffect, useMemo } from 'react';
import { useTheme } from '../ThemeContext';
import styles from './Actions.module.css';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Rating from '@mui/material/Rating';
import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import { Alert, Dialog, DialogTitle, DialogContent, DialogActions, TextField, } from '@mui/material';
import { MdOutlineFactory } from "react-icons/md";
import ButtonGroup from '@mui/material/ButtonGroup';
import { DataGrid } from '@mui/x-data-grid';
import Switch from '@mui/material/Switch';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { BiSolidAddToQueue } from "react-icons/bi";
import { MdOutlineLibraryAdd } from "react-icons/md";
import { MdAddTask } from "react-icons/md";
import Input from '@mui/material/Input';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { HiOutlineArrowLeft } from "react-icons/hi";
import { CiEdit } from "react-icons/ci";
import { CiLink } from "react-icons/ci";
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { MdAddLocationAlt } from "react-icons/md";
import { MdEditLocationAlt } from "react-icons/md";
import { MdStars } from "react-icons/md";
import FormHelperText from '@mui/material/FormHelperText';
import { IoIosArrowForward } from "react-icons/io";
import CircularProgress from '@mui/material/CircularProgress';
import { MdOutlineLibraryAddCheck } from "react-icons/md";
import { IoCheckmarkOutline } from "react-icons/io5";
import { BsPersonPlusFill } from "react-icons/bs";
import { BiSolidContact } from "react-icons/bi";
import { BsListStars } from "react-icons/bs";
import Slide from '@mui/material/Slide';
import { RiDeleteBack2Line } from "react-icons/ri";
import { BsFillInfoCircleFill } from "react-icons/bs";
import { TiDeleteOutline } from "react-icons/ti";
import { indigo } from '@mui/material/colors';
import { Chart } from "react-google-charts";
import { green } from '@mui/material/colors';
import { red } from '@mui/material/colors';
import { alpha, styled } from '@mui/material/styles';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { getUserPreferences, setUserPreferences } from '../userPreferences';


//
const Transition = React.forwardRef(function Transition(props, ref) {
  
  return <Slide direction="up" ref={ref} {...props} />;
});

const BootstrapButton = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 16,
  padding: '6px 12px',
  border: '1px solid',
  lineHeight: 1.5,
  backgroundColor: '#0063cc',
  borderColor: '#0063cc',
  fontFamily: [
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    'Roboto',
    '"Helvetica Neue"',
    'Arial',
    'sans-serif',
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(','),
  '&:hover': {
    backgroundColor: '#0069d9',
    borderColor: '#0062cc',
    boxShadow: 'none',
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: '#0062cc',
    borderColor: '#005cbf',
  },
  '&:focus': {
    boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',
  },
});

const getLocationId = (location) => location?.locationid ?? location?.LocationID ?? location?.id;
const getCompanyName = (location) => location?.CompanyName ?? location?.companyName ?? '';
const getDivisionName = (location) => location?.DivisionName ?? location?.divisionName ?? '';
const getLocationLabel = (location) => (
  location?.CompanyAndDivision
  || [getCompanyName(location), getDivisionName(location)].filter(Boolean).join(' - ')
  || String(getLocationId(location) ?? '')
);

//for green color switch
const GreenSwitch = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: green[600],
    '&:hover': {
      backgroundColor: alpha(green[600], theme.palette.action.hoverOpacity),
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: green[600],
  },
}));

const ColorButton = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText(indigo[500]),
  backgroundColor: indigo[500],
  '&:hover': {
    backgroundColor: indigo[700],
  },
}));

const REGION_OPTIONS = ['US-West', 'US-East', 'CA-West', 'CA-East', 'Aus', 'NZ', 'Europe'];
const SITE_STATUS_OPTIONS = ['Running', 'Temporary Closure', 'Permanent Closure', 'Under Construction'];
const SICAM_CUSTOMER_OPTIONS = [
  { value: '1', label: 'Yes' },
  { value: '0', label: 'No' },
];


  
//MAIN
const Actions = () => {

  const { theme } = useTheme();
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  //----------------------------ACTION TABLE COLUMNS ---------------------------------------------------------
  
  const columns = [
    { field: 'SortOrder', headerName: 'Sort Order', width: 100 },
    { field: 'ActionName', headerName: 'Action Name', width: 400 },
    { field: 'ActionTypeName', headerName: 'Action Type', width: 150 },
    { field: 'AssignedEmployeeName', headerName: 'Employee Assigned', width: 200 },
    { field: 'CompletedEmployeeName', headerName: 'Completed By', width: 200 },
    { field: 'DueDate', headerName: 'Due Date', width: 100,
    renderCell: (params) => {
      // Extracting dueDate and completedDate from row data
      const dueDate = params.row.DueDate;
      const completedDate = params.row.CompletedDate;

      // Checking if dueDate has passed and completedDate is null
      const isLate = dayjs(dueDate).isBefore(dayjs(), 'day') && completedDate === null;

      return (
        <span style={{ color: isLate ? 'red' : 'inherit' }}>
          {dueDate}
        </span>
      );
    },
    },
    { field: 'CompletedDate', headerName: 'Completed Date', width: 150 },
    {
      field: 'Edit',
      headerName: 'Edit',
      sortable: false,
      renderCell: (params) => (
        <CiEdit 
              style={{ fontSize: '30px', cursor: 'pointer' }} 
              onClick={() => handleEditClick(params.row)}
          />
      
      ),
      width: 60,
  },
  {
    field: 'Link',
    headerName: 'Status',
    sortable: false,
    renderCell: (params) => {
      const isLate = params.row.DueDate && dayjs(params.row.DueDate).isBefore(dayjs(), 'day');
      const isCompleted = params.row.CompletedDate;

      if (isCompleted) {
          // If the task is completed, display 'Completed' in green
          return <span style={{ color: 'green' }}>Completed</span>;
      } else if (isLate) {
          // If the task is late but not completed, display the link in red and add 'Late'
          return (
              <>
                  <MdOutlineLibraryAddCheck   
                      style={{ fontSize: '25px', cursor: 'pointer', color: 'red' }} 
                      onClick={() => handleLinkClick(params.row)} 
                  />
                  <span style={{ color: 'red', marginLeft: '5px' }}>Late</span>
              </>
          );
      } else {
          // If the task is not completed and not late, display the default link
          return (
            <>
              <MdOutlineLibraryAddCheck   
                  style={{ fontSize: '25px', cursor: 'pointer' }} 
                  onClick={() => handleLinkClick(params.row)} 
              />
              <span style={{ marginLeft: '3px' }}>Pending</span>
              </>
          );
      }
  },
    width: 130,
  },
  {
    field: 'Delete',
    headerName: 'Delete',
    sortable: false,
    renderCell: (params) => (
      <RiDeleteBack2Line  
            style={{ fontSize: '25px', cursor: 'pointer', paddingLeft:'10px', color:'#7d2110' }} 
            onClick={() => handleDeleteAction(params.row)}
        />
    
    ),
    width: 90,
},
  ];
  //----------------------END ACTION TABLE COLUMNS ------------------------------------------------------------------------------



  //----------------------------STANDARD PLAN ACTION TABLE COLUMNS ---------------------------------------------------------
  
   const columns2 = [
    
    { field: 'SortOrder', headerName: 'Sort Order', width: 150 },
    { field: 'ActionName', headerName: 'Action Name', width: 600 },
    { field: 'ActionTypeName', headerName: 'Action Type', width: 200 },
    { field: 'DueDateDays', headerName: 'Due Date Days', width: 150 },
    {
      field: 'Edit',
      headerName: 'Edit',
      sortable: false,
      renderCell: (params) => (
        <CiEdit 
              style={{ fontSize: '30px', cursor: 'pointer', color:'green' }} 
              onClick={() => handleEditClick2(params.row)}
          />
      
      ),
      width: 100,
  },
  {
    field: 'Delete',
    headerName: 'Delete',
    sortable: false,
    renderCell: (params) => (
      <RiDeleteBack2Line  
            style={{ fontSize: '25px', cursor: 'pointer', paddingLeft:'10px', color:'red' }} 
            onClick={() => handleEditClick3(params.row)}
        />
    
    ),
    width: 100,
},

  ];
  const getRowId = (row) => {
    // Generate a unique identifier based on row data
    return row.StandardPlanID; // Example: Assuming 'StandardPlanID' is unique
  };



    //----------------------------PREMIUM PLAN ACTION TABLE COLUMNS ---------------------------------------------------------
  
    const columns3 = [
      { field: 'SortOrder', headerName: 'Sort Order', width: 150 },
      { field: 'ActionName', headerName: 'Action Name', width: 600 },
      { field: 'ActionTypeName', headerName: 'Action Type', width: 200 },
      { field: 'DueDateDays', headerName: 'Due Date Days', width: 150 },
      {
        field: 'Edit',
        headerName: 'Edit',
        sortable: false,
        renderCell: (params) => (
          <CiEdit 
                style={{ fontSize: '30px', cursor: 'pointer', color:'green' }} 
                onClick={() => handleEditClick5(params.row)}
            />
        
        ),
        width: 100,
    },
    {
      field: 'Delete',
      headerName: 'Delete',
      sortable: false,
      renderCell: (params) => (
        <RiDeleteBack2Line  
              style={{ fontSize: '25px', cursor: 'pointer', paddingLeft:'10px', color:'red' }} 
              onClick={() => handleEditClick4(params.row)}
          />
      
      ),
      width: 100,
  },
  
    ];
  const getRowId2 = (row) => {
    // Generate a unique identifier based on row data
    return row.PremiumPlanID; // Example: Assuming 'StandardPlanID' is unique
  };
  //----------------------END ACTION TABLE COLUMNS ------------------------------------------------------------------------------


  //----------------------ALL USE STATES-----------------------------------------------------------------------------------------
  const [locationData, setLocationData] = useState([]);
  const [actionData, setActionData] = useState([]);
  const [filteredActionData, setFilteredActionData] = useState([]);
  const [company, setCompany] = React.useState('');
  const [selectedCompanyName, setSelectedCompanyName] = React.useState('');
  const [checked, setChecked] = React.useState([1]);
  const [open, setOpen] = React.useState(false);//for action dialog
  const [openNewAction, setOpenNewAction] = React.useState(false);//fpr event dialog
  const [openEditAction, setOpenEditAction] = React.useState(false);//fpr event dialog
  const [openDeleteAction, setOpenDeleteAction] = React.useState(false);//fpr event dialog
  const [openNewAction2, setOpenNewAction2] = React.useState(false);//fpr event dialog
  const [openEditAction2, setOpenEditAction2] = React.useState(false);//fpr event dialog
  const [openDeleteAction2, setOpenDeleteAction2] = React.useState(false);//fpr event dialog
  const [openDeleteAction3, setOpenDeleteAction3] = React.useState(false);//fpr event dialog
  const [refreshData, setRefreshData] = useState(false);
  const [showCompleted, setShowCompleted] = useState(true); 
  const [togglePreferencesLoadedFor, setTogglePreferencesLoadedFor] = useState('');
  const [actionTypeData, setActionTypeData] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);
  const [companyData, setCompanyData] = useState([]);
  const [divisionData, setDivisionData] = useState([]);
  const [contactData, setContactData] = useState([]);
  const [standardPlanData, setStandardPlanData] = useState([]);
  const [premiumPlanData, setPremiumPlanData] = useState([]);
  const [isActionCompleted, setIsActionCompleted] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isDialogOpen2, setIsDialogOpen2] = useState(false);
  const [totalActions, setTotalActions] = useState(false);
  const [completedActions, setCompletedActions] = useState(false);
  const [completionPercentage, setCompletionPercentage] = useState(0);
  const [addLocationOpen, setAddLocationOpen] = useState(false);
  const [editLocationOpen, setEditLocationOpen] = useState(false);
  const [addContactOpen, setAddContactOpen] = useState(false);
  const [editContactOpen, setEditContactOpen] = useState(false);
  const [editBasicPlanOpen, setEditBasicPlanOpen] = useState(false);
  const [editPremiumPlanOpen, setEditPremiumPlanOpen] = useState(false);
  const [isCompanySwitchOn, setIsCompanySwitchOn] = useState(false); // State to track the switch position
  const [isContactSwitchOn, setIsContactSwitchOn] = useState(false); // State to track the switch position
  const [customerInfo, setCustomerInfo] = useState(''); // State to track the selected option from the dropdown
  const [textFieldValue, setTextFieldValue] = useState(''); // State to track the input from the text field
  const [editPlanOpen, setEditPlanOpen] = useState(false);
  const [actionTypeDialogOpen, setActionTypeDialogOpen] = useState(false);
  const [newActionTypeName, setNewActionTypeName] = useState('');
  const [newActionTypeFeedback, setNewActionTypeFeedback] = useState({ severity: '', message: '' });
  const [actionTypeDialogTarget, setActionTypeDialogTarget] = useState('');
  const [editFormData, setEditFormData] = useState({
    actionID: '',
    locationID: '',
    actionName: '',
    actionType: '',
    actionEmployee: '',
    completedEmployee:'',
    dueDate: null,
    completedDate: null,
    sortOrder: '',
     
});

const [formData, setFormData] = useState({
  locationID: '',
  actionName: '',
  actionType: '',
  actionEmployee: '',
  completedEmployee:'',
  dueDate: null,
  completedDate: null,
  sortOrder: '',
  
});



const [addLocationData, setAddLocationData] = useState({
  companyID: '',
  companyName: null,
  divisionName: '',
  address: '',
  postal: '',
  city: '',
  state: '',
  country: '',
  longitude:null,
  latitude:null,
  region: '',
  siteStatus: '',
  siCamCustomer: '',
  locationID:'',
});
const [addLocationFeedback, setAddLocationFeedback] = useState({ severity: '', message: '' });
const [editLocationData, setEditLocationData] = useState({
  companyID: '',
  companyName: null,
  divisionName: '',
  address: '',
  postal: '',
  city: '',
  state: '',
  country: '',
  longitude:null,
  latitude:null,
  region: '',
  siteStatus: '',
  siCamCustomer: '',
  locationID:'',
  divisionID:'',
});

const [editPlanData, setEditPlanData] = useState({
        
  locationID:'',
  supportStatusBefore:'',
  supportStatusAfter:'',
  supportStartDateBefore:null,
  supportEndDateBefore:null,
  supportStartDateAfter:null,
  supportEndDateAfter:null,
  employee:'',
});
const [editPlanFeedback, setEditPlanFeedback] = useState({ severity: '', message: '' });

const [addContactData, setAddContactData] = useState({
        
  locationID:'',
  firstName:'',
  lastName:'',
  title:'',
  email:'',
  cell:null,
  office:null,
  ext:null,
});

const [editContactData, setEditContactData] = useState({
  contactID:'',      
  locationID:'',
  firstName:'',
  lastName:'',
  title:'',
  email:'',
  cell:null,
  office:null,
  ext:null,
});
const [editActionDataPlan, setEditActionDataPlan] = useState({
  standardPlanID: '',
  premiumPlanID: '',
  actionName: '',
  actionTypeID: '',
  dueDays: '',
  sortOrder: '',
     
});
const [deleteActionSDataPlan, setDeleteActionSDataPlan] = useState({
  standardPlanID: '',
  
      
});
const [deleteActionPDataPlan, setDeleteActionPDataPlan] = useState({
  premiumPlanID: '',
      
});
const [deleteAction, setDeleteAction] = useState({
  ActionID: '',
      
});
const [addActionDataSPlan, setAddActionDataSPlan] = useState({
  actionName: '',
  actionTypeID: '',
  dueDays: '',
  sortOrder: '',
     
});
const [addActionDataPPlan, setAddActionDataPPlan] = useState({
  actionName: '',
  actionTypeID: '',
  dueDays: '',
  sortOrder: '',
     
});
  const [selectedLocation, setSelectedLocation] = useState(""); // ✅ Store selected location ID

  const companyOptions = useMemo(() => {
    const seen = new Set();
    return locationData.reduce((options, location) => {
      const companyName = getCompanyName(location);
      if (companyName && !seen.has(companyName)) {
        seen.add(companyName);
        options.push(companyName);
      }
      return options;
    }, []);
  }, [locationData]);

  const filteredMainLocations = useMemo(() => {
    if (!selectedCompanyName) return [];
    return locationData.filter((location) => getCompanyName(location) === selectedCompanyName);
  }, [locationData, selectedCompanyName]);


//---------------------------------------------------------------------------------------------------------------------------------------------



//-----------------------------FETCH SQL DATA--------------------------------------------------------------------------------------------------
const fetchData = async () => {
  try {
    //console.log(config.ipAddress);

      const response = await fetch(`/api/`);
      const result = await response.json();

     // 'ActionID' is unique
    const actionDataWithId = result.actionTable.map(item => ({
      ...item,
      DueDate: item.DueDate ? item.DueDate.split('T')[0] : null, // Ensure DueDate is in 'YYYY-MM-DD' format
      CompletedDate: item.CompletedDate ? item.CompletedDate.split('T')[0] : null, // Ensure CompletedDate is in 'YYYY-MM-DD' format
      id: item.ActionID,
    }));

    
      //all the SQL tables
      setLocationData(result.locationTable);
      setActionData(actionDataWithId);
      setActionTypeData(result.actionTypeTable);
      setEmployeeData(result.employeeTable);
      setCompanyData(result.companyTable);
      setDivisionData(result.divisionTable);
      setContactData(result.contactTable);
      setStandardPlanData(result.standardPlanTable);
      setPremiumPlanData(result.premiumPlanTable);

   
      
  } catch (error) {
      console.error('Error fetching data:', error);
  }
  };

  
  //------------------------------END FETCH SQL DATA-------------------------------------------------------------------------------------------



  //------------------------------USE EFFECTS------------------------------------------------------------------------------
  
  //for fetching SQL data
  useEffect(() => {
    fetchData();
    }, [refreshData]);

  useEffect(() => {
    const normalizedEmail = String(user?.email || '').trim().toLowerCase();
    if (!normalizedEmail) {
      setTogglePreferencesLoadedFor('');
      return;
    }

    const preferences = getUserPreferences(normalizedEmail);
    setShowCompleted(typeof preferences.actionsShowCompleted === 'boolean' ? preferences.actionsShowCompleted : true);
    setTogglePreferencesLoadedFor(normalizedEmail);
  }, [user?.email]);

  useEffect(() => {
    const normalizedEmail = String(user?.email || '').trim().toLowerCase();
    if (!normalizedEmail || togglePreferencesLoadedFor !== normalizedEmail) {
      return;
    }

    setUserPreferences(normalizedEmail, {
      actionsShowCompleted: showCompleted,
    });
  }, [showCompleted, togglePreferencesLoadedFor, user?.email]);


  //for filtering data based on 'Show Completed' switch and also calculates percentage..
  useEffect(() => {
      const filteredData = actionData.filter(item => 
          (String(item.LocationID) === String(company)) && (showCompleted || item.CompletedDate == null)
      );

      //find contacts with selected location ID
      const currentCustomer = contactData.filter(item => 
        (String(item.LocationID) === String(company)) 
    );

   // console.log("currentCustomer",currentCustomer);
            
      setFilteredActionData(filteredData);
      setTotalActions(filteredData.length);
      setCompletedActions(filteredData.filter(item => item.CompletedDate != null).length);
      setCustomerInfo(currentCustomer);


  }, [actionData, company, showCompleted, contactData]); // Dependencies to re-run this effect
  
  // Separate useEffect for calculating completion percentage as it was lagging behind.
  useEffect(() => {
      // Calculate the percentage of completed actions
      const percentage = totalActions > 0 ? ((completedActions / totalActions) * 100) : 0;
      setCompletionPercentage(percentage);
  }, [totalActions, completedActions]); // This useEffect depends on totalActions and completedActions  

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const adminAction = params.get('admin');

    if (!adminAction) {
      return;
    }

    if (adminAction === 'add-location') {
      handleAddLocationOpen();
    }

    if (adminAction === 'edit-location') {
      handleEditLocationOpen();
    }

    if (adminAction === 'support-plan') {
      handleEditPlanOpen();
    }

    if (adminAction === 'contact') {
      handleAddContactOpen();
    }

    navigate(location.pathname, { replace: true });
  }, [location.pathname, location.search, navigate]);

//---------------------------------------USE EFFECTS END--------------------------------------------------



//------------------------------------HANDLE CLICKS (ONCLICK) FUNCTIONS----------------------------------


//for opening ADD LOCATION dialog
  const handleAddLocationOpen = () => {
    setAddLocationFeedback({ severity: '', message: '' });
    setAddLocationOpen(true);
  };
  const handleAddLocationClose = () => {
    setAddLocationFeedback({ severity: '', message: '' });
    setAddLocationOpen(false);
  };
//--------------------------------
  //for opening EDT LOCATION dialog
  const handleEditLocationOpen = () => {
    setEditLocationOpen(true);
  };
  const handleEditLocationClose = () => {
    setEditLocationOpen(false);
  };
//--------------------------------
  //for opening EDIT PLAN dialog
const handleEditPlanOpen = () => {
    setEditPlanFeedback({ severity: '', message: '' });
    setEditPlanOpen(true);
  };
const handleEditPlanClose = () => {
    setEditPlanFeedback({ severity: '', message: '' });
    setEditPlanOpen(false);
  };

  const handleOpenActionTypeDialog = (target) => {
    setActionTypeDialogTarget(target);
    setNewActionTypeName('');
    setNewActionTypeFeedback({ severity: '', message: '' });
    setActionTypeDialogOpen(true);
  };

  const handleCloseActionTypeDialog = () => {
    setActionTypeDialogOpen(false);
    setNewActionTypeName('');
    setNewActionTypeFeedback({ severity: '', message: '' });
    setActionTypeDialogTarget('');
  };
//--------------------------------
  //for opening ADD ACTION DIALOG
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
//--------------------------------
//for opening ADD CONTACT dialog
const handleAddContactOpen = () => {
  setAddContactOpen(true);
};
const handleAddContactClose = () => {
  setAddContactOpen(false);
};

//--------------------------------
//for opening EDIT CONTACT dialog
const handleEditContactOpen = () => {
  handleAddContactClose();
  setEditContactOpen(true);
};
const handleEditContactClose = () => {
  setEditContactOpen(false);
};
//--------------------------------

//for opening EDIT CONTACT dialog
const handleEditBasicPlanOpen = () => {
  handleEditPlanClose();
  setEditBasicPlanOpen(true);
};
const handleEditBasicPlanClose = () => {
  setEditBasicPlanOpen(false);
};
//--------------------------------
//--------------------------------
//for opening EDIT CONTACT dialog
const handleEditPremiumPlanOpen = () => {
  handleEditPlanClose();
  setEditPremiumPlanOpen(true);
};
const handleEditPremiumPlanClose = () => {
  setEditPremiumPlanOpen(false);
};
//--------------------------------
//--------------------------------
  //for opening ADD ACTION DIALOG
  const handleNewActionDialogOpen = () => {
    setOpenNewAction(true);
  };

  const handleNewActionDialogClose = () => {
    setOpenNewAction(false);
  };
//--------------------------------
//--------------------------------
  //for opening EDIT ACTION DIALOG - Standard Plan
  const handleEditActionDialogOpen = () => {
    setOpenEditAction(true);
  };

  const handleEditActionDialogClose = () => {
    setOpenEditAction(false);
  };
//--------------------------------
//--------------------------------
  //for opening DELETING ACTION DIALOG - Standard Plan
  const handleDeleteActionDialogOpen = () => {
    setOpenDeleteAction(true);
  };

  const handleDeleteActionDialogClose = () => {
    setOpenDeleteAction(false);
  };
//--------------------------------
//--------------------------------
  //for opening ADD ACTION DIALOG
  const handleNewActionDialogOpen2 = () => {
    setOpenNewAction2(true);
  };

  const handleNewActionDialogClose2 = () => {
    setOpenNewAction2(false);
  };
//--------------------------------
//--------------------------------
  //for opening EDIT ACTION DIALOG - Standard Plan
  const handleEditActionDialogOpe2 = () => {
    setOpenEditAction2(true);
  };

  const handleEditActionDialogClose2 = () => {
    setOpenEditAction2(false);
  };
//--------------------------------
//--------------------------------
  //for opening DELETING ACTION DIALOG - Standard Plan
  const handleDeleteActionDialogOpen2 = () => {
    setOpenDeleteAction2(true);
  };

  const handleDeleteActionDialogClose2 = () => {
    setOpenDeleteAction2(false);
  };
//--------------------------------
//--------------------------------
  //for opening DELETING ACTION DIALOG - Standard Plan
  const handleDeleteActionDialogOpen3 = () => {
    setOpenDeleteAction3(true);
  };

  const handleDeleteActionDialogClose3 = () => {
    setOpenDeleteAction3(false);
  };
//--------------------------------


//---------------------------------
//Handle 1: FOR LOCATION DROP DOWN   
//---------------------------------
const updateMainLocation = (locationId) => {
  const nextLocationId = locationId === undefined || locationId === null ? '' : String(locationId);
  setCompany(nextLocationId);
  setFormData(prevState => ({
    ...prevState,
    locationID: nextLocationId,
  }));
};

const handleChangeMainCompany = (event) => {
  const newCompanyName = event.target.value;
  setSelectedCompanyName(newCompanyName);

  const firstLocation = locationData.find((location) => getCompanyName(location) === newCompanyName);
  updateMainLocation(getLocationId(firstLocation));
};

const handleChangeMainLocation = (event) => {
  updateMainLocation(event.target.value);
};

//----------------END--------------------------

//---------------------------------------------
//Handle 2: FOR ADDING NEW ACTION DIALOG
//---------------------------------------------
 
const handleChangeNewAction = (field, event) => {
   
  const value = event.target ? event.target.value : event;
  setFormData(prevState => ({
    ...prevState,
    [field]: value,
    
  }));

};
//----------------END--------------------------

//---------------------------------------------
//Handle 3: FOR EDITING ACTION DIALOG
//
const handleChangeEditAction = (field, event) => {

   
  if (event === undefined) {
      console.error('handleChangeEditAction: No value provided for field', field);
      return; 
  }

  // Determine whether 'event' is an event object or a direct value
  const newValue = event.target ? event.target.value : event;
   
  // Update the editFormData state
  setEditFormData(prevState => ({
      ...prevState,
      [field]: newValue,
  }));
  //console.log("handleChangeEditData-EditFormData: ", editFormData);
};
//----------------END------------------------



//---------------------------------------------
//Handle 4: FOR EDITING EACH ROW IN THE TABLE
//---------------------------------------------
const handleEditClick = (rowData) => {

console.log("row data", rowData);

const actionType = actionTypeData.find(type => type.ActionTypeName === rowData.ActionTypeName);
const employeeType = employeeData.find(type => type.EmployeeName === rowData.AssignedEmployeeName);
const employeeType2 = employeeData.find(type => type.EmployeeName === rowData.CompletedEmployeeName);

// console.log("action type", actionType);
// console.log("emp type1", employeeType);
// console.log("emp type2", employeeType2);

if (actionType) {
  
  setEditFormData(prevState => ({
      ...prevState,
      actionTypeID: actionType.ActionTypeID 
  }));
} else {
  console.log("No matching action type found for:", rowData.ActionTypeName);
  
}

setEditFormData({
    ...editFormData, // Spread in existing form data
    actionID: rowData.ActionID,
    locationID: rowData.LocationID, 
    actionName: rowData.ActionName,
    actionType:actionType ? actionType.ActionTypeID : '', 
    actionEmployee: employeeType ? employeeType.EmployeeID : '',
    completedEmployee:employeeType2 ? employeeType2.EmployeeID : '',
    dueDate: dayjs(rowData.DueDate), 
    completedDate: rowData.CompletedDate, 
    sortOrder: rowData.SortOrder,
    
});
console.log("EditFormData", editFormData);
setIsDialogOpen(true); // Open the dialog

};
//----------------END------------------------



//---------------------------------------------
//Handle 5: FOR LINKING EACH ROW IN THE TABLE DIALOG
//---------------------------------------------
const handleLinkClick = (rowData) => {
setEditFormData({
  ...editFormData, // Carry over existing data
  actionName: rowData.ActionName,
  actionID: rowData.ActionID, // 
  
});
console.log("handleLinkClick-rowData: ", rowData);
setIsDialogOpen2(true); // Assuming this is the state controlling the visibility of your dialog
};
//----------------END------------------------



//---------------------------------------------
//Handle 6: FOR ADDING NEW LOCATION DIALOG
//---------------------------------------------
const handleChangeAddLocation = (field, event) => {
    const value = event.target ? event.target.value : event;
    setAddLocationData({
        ...addLocationData,
        ...(field === 'companyID' ? { companyName: null } : {}),
        ...(field === 'companyName' ? { companyID: '' } : {}),
        [field]: value,
    });

    console.log("handleChangeAddLocation", addLocationData);
};
//----------------END------------------------

//---------------------------------------------
//Handle 7: FOR EDITING LOCATION DIALOG
//---------------------------------------------
const handleChangeEditLocation = (field, event) => {
  const value = event.target ? event.target.value : event;
  setEditLocationData({
      ...editLocationData,
      [field]: value,
  });

  console.log("handleChangeEditLocation", editLocationData);
};
 //----------------END------------------------


//---------------------------------------------
//Handle 8: THIS FOR ADD ACTION DIALOG
//          SWITCH FOR CHECKING IF ACTION IS COMPLETED
//---------------------------------------------
  
const handleSwitchChangeActionCompleted = (event) => {
  // Update the state to reflect the new status of the switch
  setIsActionCompleted(event.target.checked);

  // Check if the switch is turned ON
  if (event.target.checked) {
      // If yes, set the completedDate in formData to today's date
      const today = new dayjs().format('YYYY-MM-DD'); // Format today's date as 'YYYY-MM-DD'
      setFormData(prevState => ({
          ...prevState,
          completedDate: today,
          
      }));
  } else {
      // If the switch is turned OFF, remove the completedDate from formData
      setFormData(prevState => ({
          ...prevState,
          completedDate: null, // Clear the completedDate field
          completedEmployee:'',
          
      }));
  }
}; 
//----------------END------------------------




//---------------------------------------------
//Handle 9: THIS FOR ADD LOCATION DIALOG
//          SWITCH FOR CHECKING IF COMPANY IS NEW
//-----------------------------------------------
const handleSwitchNewCompany = (event) => {
    const checked = event.target.checked;
    setIsCompanySwitchOn(checked);
    setAddLocationFeedback({ severity: '', message: '' });
    setAddLocationData((prevState) => ({
      ...prevState,
      companyID: checked ? '' : prevState.companyID,
      companyName: checked ? prevState.companyName : null,
    }));
};
//----------------END------------------------



//---------------------------------------------
//Handle 10: THIS FOR EDIT LOCATION DIALOG
//          FOR SELECTING LOCATION TO EDIT
//-----------------------------------------------
// const handleSelectLocation = (event) => {
//   const locationID = event.target.value;
//   const selectedLocation = locationData.find(location => location.LocationID === locationID);
//   const companyObject = companyData.find(company => company.CompanyName === selectedLocation.CompanyName);
//   const divisionObject = divisionData.find(division => division.DivisionName === selectedLocation.DivisionName);
//   if (selectedLocation) {
//       setEditLocationData({
//           companyID: companyObject.CompanyID,
//           companyName: selectedLocation.CompanyName,
//           divisionName: selectedLocation.DivisionName,
//           address: selectedLocation.Address,
//           postal: selectedLocation.Postal,
//           city: selectedLocation.City,
//           state: selectedLocation.State,
//           country: selectedLocation.Country,
//           longitude: selectedLocation.Longitude,
//           latitude: selectedLocation.Latitude,
//           locationID: locationID,
//           divisionID: divisionObject.DivisionID,
//       });
//   }
// };
const handleSelectLocation = (event) => {
  const locationID = event.target.value;
  setSelectedLocation(locationID); // ✅ Store selected location for deletion

  const selectedLocation = locationData.find(location => location.LocationID === locationID);
  const companyObject = companyData.find(company => company.CompanyName === selectedLocation.CompanyName);
  const divisionObject = divisionData.find(division => division.DivisionName === selectedLocation.DivisionName);
  
  if (selectedLocation) {
      setEditLocationData({
          companyID: companyObject?.CompanyID || "",
          companyName: selectedLocation.CompanyName,
          divisionName: selectedLocation.DivisionName,
          address: selectedLocation.Address,
          postal: selectedLocation.Postal,
          city: selectedLocation.City,
          state: selectedLocation.State,
          country: selectedLocation.Country,
          longitude: selectedLocation.Longitude,
          latitude: selectedLocation.Latitude,
          region: selectedLocation.Region || '',
          siteStatus: selectedLocation.SiteStatus || '',
          siCamCustomer: selectedLocation.SiCamCustomer === null || selectedLocation.SiCamCustomer === undefined
            ? ''
            : (selectedLocation.SiCamCustomer ? '1' : '0'),
          locationID: locationID,
          divisionID: divisionObject?.DivisionID || "",
      });
  }
};

//----------------END------------------------

//---------------------------------------------
//Handle 11: THIS FOR ASSIGN PLAN DIALOG
//          FOR SELECTING LOCATION TO ASSIGN PLAN TO
//-----------------------------------------------
const handleSelectLocationPlan = async (event) => {
const locationID = event.target.value;
const selectedLocation = locationData.find(location => location.LocationID === locationID);

if (selectedLocation) {
  setEditPlanData({
       
        locationID: locationID,
        supportStatusBefore: selectedLocation.SupportStatus,
        supportStartDateBefore: selectedLocation.SupportStartDate ? selectedLocation.SupportStartDate : null ,
        supportEndDateBefore: selectedLocation.SupportEndDate ? selectedLocation.SupportEndDate : null,
        supportStatusAfter: '',
        supportStartDateAfter: null,
        supportEndDateAfter: null,
        employee: '',
    });
  setEditPlanFeedback({ severity: '', message: '' });
}
};

//----------------END------------------------


//---------------------------------------------
//Handle 12: THIS FOR ASSIGN PLAN DIALOG
//          FOR DETECTING CHANGE IN  START DATE
//-----------------------------------------------
const handleStartDateChange = (newValue) => {
  const newStartDate = newValue; // New start date selected by the user
  const newEndDate = newStartDate ? dayjs(newStartDate).add(1, 'year').format('YYYY-MM-DD') : null; // Add one year to the start date and format
  console.log("newStartDate",newStartDate);
  setEditPlanData({ 
      ...editPlanData, 
      supportStartDateAfter: newStartDate ? dayjs(newStartDate).format('YYYY-MM-DD') : null, // Format the new start date
      supportEndDateAfter: newEndDate // Set the formatted new end date
  });
};
//----------------END------------------------


//---------------------------------------------
//Handle 13: FOR ADDING NEW CONTACT DIALOG
//---------------------------------------------
const handleChangeAddContact = (field, event) => {
  const value = event.target ? event.target.value : event;
  setAddContactData({
      ...addContactData,
      [field]: value,
  });

  console.log("handleChangeAddContact", addContactData);
};
//----------------END------------------------


//---------------------------------------------
//Handle 14: THIS FOR EDITING CONTACT 
//          
//-----------------------------------------------
const handleChangeEditContact = (field, event) => {
  const value = event.target ? event.target.value : event;
  setEditContactData({
      ...editContactData,
      [field]: value,
  });

  console.log("handleChangeAddContact", addContactData);
};
//----------------END------------------------

//---------------------------------------------
//Handle 15: THIS FOR EDIT CONTACT DIALOG
//          WHEN CONTACT LIST IS CHANGED
//-----------------------------------------------
const handleSelectContact = (event) => {
  const contactID= event.target.value;
  
  const selectedContact = contactData.find(contact => contact.ContactID === contactID);
  console.log("selectedContact",selectedContact);

  setEditContactData({
    contactID:   contactID ,
    locationID:selectedContact.LocationID,
    firstName:selectedContact.FirstName,
    lastName:selectedContact.LastName,
    title:selectedContact.Title,
    email:selectedContact.Email,
    cell:selectedContact.CellPhone,
    office:selectedContact.OfficePhone,
    ext:selectedContact.PhoneExtension,
  });
 
  
};
//----------------END------------------------
//---------------------------------------------
//Handle 16: FOR ASSIGNING EMP TO PLAN DIALOG
//
const handleChangeAssignEmp = (field, event) => {

   
  if (event === undefined) {
      console.error('handleChangeEditAction: No value provided for field', field);
      return; 
  }

  // Determine whether 'event' is an event object or a direct value
  const newValue = event.target ? event.target.value : event;
   
  // Update the editFormData state
  setEditPlanData(prevState => ({
      ...prevState,
      [field]: newValue,
  }));
  //console.log("handleChangeEditData-EditFormData: ", editFormData);
};
//----------------END------------------------
//---------------------------------------------
//Handle 17: FOR EDITING ACTION IN THE PLAN TABLE when Edit button is clicked
//---------------------------------------------
const handleEditClick2 = (rowData) => {

  console.log("row data2", rowData);
  
  const actionType = actionTypeData.find(type => type.ActionTypeName === rowData.ActionTypeName);
  console.log("action type", actionType);

  
  if (actionType) {
    
    setEditActionDataPlan(prevState => ({
        ...prevState,
        actionTypeID: actionType.ActionTypeID 
    }));
  } else {
    console.log("No matching action type found for:", rowData.ActionTypeName);
    
  }

  
  setEditActionDataPlan({
      ...editActionDataPlan, // Spread in existing form data
      standardPlanID: rowData.StandardPlanID,
      premiumPlanID: rowData.PremiumPlanID, 
      actionName: rowData.ActionName,
      actionTypeID:actionType ? actionType.ActionTypeID : '', 
      dueDays: rowData.DueDateDays,
      sortOrder: rowData.SortOrder,
     
      
  });
  console.log("EditActionDataPlan", editActionDataPlan);
  setOpenEditAction(true); // Open the dialog
  
  };
  //----------------END------------------------
  //---------------------------------------------
//Handle 18: FOR EDITING ACTION DIALOG i PLAN TABLE when change is made via onChange method
//
const handleChangeEditAction2 = (field, event) => {

   
  if (event === undefined) {
      console.error('handleChangeEditAction2: No value provided for field', field);
      return; 
  }

  // Determine whether 'event' is an event object or a direct value
  const newValue = event.target ? event.target.value : event;
   
  // Update the editFormData state
  setEditActionDataPlan(prevState => ({
      ...prevState,
      [field]: newValue,
  }));
  console.log("EditActionDataPlan", editActionDataPlan);

};
//----------------END------------------------

//---------------------------------------------
//Handle 19: FOR DELETING ACTION IN THE PLAN TABLE when Edit button is clicked in STANDARD PLAN
//---------------------------------------------
const handleEditClick3 = (rowData) => {

  //console.log("row data2", rowData);
  setDeleteActionSDataPlan({
      ...deleteActionSDataPlan, // Spread in existing form data
      standardPlanID: rowData.StandardPlanID,
     
  });
  console.log("deleteActionSDataPlan", deleteActionSDataPlan);
  setOpenDeleteAction(true); // Open the dialog
  
  };
  //----------------END------------------------
  //---------------------------------------------
//Handle 20: FOR ADDING NEW ACTION DIALOG IN STANDARD PLAN
//---------------------------------------------
 
const handleChangeNewActionSPlan = (field, event) => {
   
  const value = event.target ? event.target.value : event;
  setAddActionDataSPlan(prevState => ({
    ...prevState,
    [field]: value,
    
  }));

};
//----------------END--------------------------
//Handle 21: FOR ADDING NEW ACTION DIALOG IN PREMIUM PLAN
//---------------------------------------------
 
const handleChangeNewActionPPlan = (field, event) => {
   
  const value = event.target ? event.target.value : event;
  setAddActionDataPPlan(prevState => ({
    ...prevState,
    [field]: value,
    
  }));

};
//----------------END--------------------------
//---------------------------------------------
//Handle 22: FOR DELETING ACTION IN THE PLAN TABLE when Edit button is clicked in STANDARD PLAN
//---------------------------------------------
const handleEditClick4 = (rowData) => {

  console.log("row data3", rowData);
  setDeleteActionPDataPlan({
      ...deleteActionPDataPlan, // Spread in existing form data
      premiumPlanID: rowData.PremiumPlanID,
     
  });
  console.log("deleteActionPDataPlan", deleteActionPDataPlan);
  setOpenDeleteAction2(true); // Open the dialog
  
  };
  //----------------END------------------------
  //---------------------------------------------
//Handle 23: FOR EDITING ACTION IN THE PLAN TABLE when Edit button is clicked
//---------------------------------------------
const handleEditClick5 = (rowData) => {

  console.log("row data2", rowData);
  
  const actionType = actionTypeData.find(type => type.ActionTypeName === rowData.ActionTypeName);
  console.log("action type", actionType);

  
  if (actionType) {
    
    setEditActionDataPlan(prevState => ({
        ...prevState,
        actionTypeID: actionType.ActionTypeID 
    }));
  } else {
    console.log("No matching action type found for:", rowData.ActionTypeName);
    
  }

  
  setEditActionDataPlan({
      ...editActionDataPlan, // Spread in existing form data
      standardPlanID: rowData.StandardPlanID,
      premiumPlanID: rowData.PremiumPlanID, 
      actionName: rowData.ActionName,
      actionTypeID:actionType ? actionType.ActionTypeID : '', 
      dueDays: rowData.DueDateDays,
      sortOrder: rowData.SortOrder,
      
  });
  console.log("EditActionDataPlan", editActionDataPlan);
  setOpenEditAction2(true); // Open the dialog
  
  };
  //----------------END------------------------
  //---------------------------------------------
//Handle 24: FOR DELETING ACTION IN THE PLAN TABLE when Edit button is clicked in STANDARD PLAN
//---------------------------------------------
const handleDeleteAction = (rowData) => {

  console.log("handleDeleteAction", rowData);
  setDeleteAction({
      ...deleteAction, // Spread in existing form data
      ActionID: rowData.ActionID,
     
  });
  console.log("handleDeleteAction", deleteAction);
  setOpenDeleteAction3(true); // Open the dialog
  
  };
  //----------------END------------------------
    //---------------------------------------------
//Handle 25: FOR DELETING LOCATION
//---------------------------------------------

const handleDeleteLocation = async () => {
  if (!selectedLocation) {
    alert("Please select a location to delete.");
    return;
  }

  // ✅ Ask for confirmation before proceeding
  const isConfirmed = window.confirm("Are you sure you want to delete this location? This will also delete all actions, contacts, zones, and support history associated with this location - This cannot be undone!");
  if (!isConfirmed) return; // ✅ If user cancels, stop execution

  try {
    console.log("Deleting Location:", selectedLocation);
    
    const response = await fetch(`/api/deleteLocation/${selectedLocation}`, {
      method: 'POST', 
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ locationID: selectedLocation }), 
    });

    if (!response.ok) throw new Error('Failed to delete location');

    // ✅ Update UI: Remove deleted location from dropdown
    setLocationData(prevData => prevData.filter(loc => String(getLocationId(loc)) !== String(selectedLocation)));
    if (String(company) === String(selectedLocation)) {
      updateMainLocation('');
      setSelectedCompanyName('');
    }

    setSelectedLocation(""); // ✅ Reset dropdown selection
    alert("Location deleted successfully!");
  } catch (error) {
    console.error("Error deleting location:", error);
    alert("Error deleting location. Please try again.");
  }
};
 
//----------------END------------------------

 //------------------------MISCS FUNCTIONS----------------------- 
  const selectedCompanyObj = locationData.find(location => String(getLocationId(location)) === String(company));
  //console.log("selectedCompany",selectedCompanyObj );

  const getSupportStatusText = (status) => {
    switch (status) {
      case 2:
        return "Standard Maintenance Program";
      case 3:
        return "Premium Maintenance Program";
      default:
        return "Basic Maintenance Program"; // Optional: handle unexpected or missing status
    }
  };
  
  //For finding number of remaining support days.
  const calculateRemainingDays = (endDate) => {
    // Current date without time part
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset hours, minutes, seconds, and milliseconds
    // End date from the selectedCompanyObj
    const end = new Date(endDate);
    end.setHours(0, 0, 0, 0); // Reset hours, minutes, seconds, and milliseconds for consistent comparison
    // Calculate the difference in milliseconds
    const difference = end - today;
    // Convert the difference to days
    const remainingDays = parseInt(difference / (1000 * 60 * 60 * 24));
    return remainingDays < 0 ? 'Expired' : remainingDays;
  };

  

//--------------------SQL POSTS--------------------------------------------------------------------------------
  
const handleSubmitNewAction = async () => {
      
  console.log("new action data" ,formData);
  try {
    const response = await fetch(`/api/addAction`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    if (!response.ok) throw new Error('Failed to save action');
    // Toggle refreshData to trigger data re-fetching
    setRefreshData(prev => !prev);
    console.log('Action saved successfully');
    handleClose(); // Close dialog on success
    setFormData({
      locationID: formData.locationID,
      actionName: '',
      actionType: '',
      actionEmployee: '',
      dueDate: null,
      completedDate: null,
      completedEmployee:'',
      sortOrder: '',
  });


  } catch (error) {
    console.error('Error saving action:', error);
  }
  
};
//------------------------------------------------------------

const handleEditActionSave = async () => {
  try {
     
      console.log("handleEditActionSave",editFormData);
      const response = await fetch(`/api/updateAction/${editFormData.actionID}`, {
          method: 'POST', // or 'PATCH'
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(editFormData),
          
      });
      if (!response.ok) throw new Error('Failed to update action');

      setIsDialogOpen(false); // Close the dialog
      setRefreshData((prev) => !prev); // Trigger a re-fetch of the grid data
  } catch (error) {
      console.error('Error updating action:', error);
  }
};

//---------------------------------------------------------------
const handleSubmitAddLocation = async () => {
  setAddLocationFeedback({ severity: '', message: '' });

  if (!isCompanySwitchOn && !addLocationData.companyID) {
    setAddLocationFeedback({ severity: 'error', message: 'Select an existing company before saving the location.' });
    return;
  }

  if (isCompanySwitchOn && !String(addLocationData.companyName || '').trim()) {
    setAddLocationFeedback({ severity: 'error', message: 'Enter a company name before saving the location.' });
    return;
  }

  if (!String(addLocationData.divisionName || '').trim()) {
    setAddLocationFeedback({ severity: 'error', message: 'Enter a division name before saving the location.' });
    return;
  }

  try {
    const response = await fetch(`/api/addLocation`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(addLocationData),
    });

    let payloadMessage = '';
    const contentType = response.headers.get('content-type') || '';
    if (contentType.includes('application/json')) {
      const payload = await response.json();
      payloadMessage = payload?.message || '';
    } else {
      payloadMessage = await response.text();
    }

    if (!response.ok) throw new Error(payloadMessage || 'Failed to save location');

    setRefreshData(prev => !prev);
    setAddLocationFeedback({ severity: 'success', message: payloadMessage || 'Location added successfully.' });

    setAddLocationData({
      companyID: '',
      companyName: null,
      divisionName: '',
      address: '',
      postal: '',
      city: '',
      state: '',
      country: '',
      longitude: null,
      latitude: null,
      region: '',
      siteStatus: '',
      siCamCustomer: '',
      locationID: '',
    });
    setIsCompanySwitchOn(false);

  } catch (error) {
    console.error('Error saving location:', error);
    setAddLocationFeedback({ severity: 'error', message: error.message || 'An error occurred while saving the location.' });
  }
};
  const handleSubmitEditLocation = async () => {
      
    //console.log("formdata" ,formData);
    try {
      const response = await fetch(`/api/editLocation`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(editLocationData),
      });
      if (!response.ok) throw new Error('Failed to save action');
      // Toggle refreshData to trigger data re-fetching
      setRefreshData(prev => !prev);
      console.log('Action saved successfully');
      handleEditLocationClose(); // Close dialog on success
      setEditLocationData({
        companyID: '',
        companyName: null,
        divisionName: '',
        address: '',
        postal: '',
        city: '',
        state: '',
        country: '',
        longitude: null,
        latitude: null,
        region: '',
        siteStatus: '',
        siCamCustomer: '',
        locationID:'',
        divisionID:'',
    });

    } catch (error) {
      console.error('Error saving action:', error);
    }
    
  };

  const handleSubmitEditPlan = async () => {
    setEditPlanFeedback({ severity: '', message: '' });

    if (!editPlanData.locationID) {
      setEditPlanFeedback({ severity: 'error', message: 'Select a location before saving the support plan.' });
      return;
    }

    if (![1, 2, 3].includes(Number(editPlanData.supportStatusAfter))) {
      setEditPlanFeedback({ severity: 'error', message: 'Choose a new maintenance plan before saving.' });
      return;
    }

    if (Number(editPlanData.supportStatusAfter) !== 1) {
      if (!editPlanData.supportStartDateAfter) {
        setEditPlanFeedback({ severity: 'error', message: 'Choose a start date for the new support plan.' });
        return;
      }

      if (!editPlanData.employee) {
        setEditPlanFeedback({ severity: 'error', message: 'Assign a SiCam employee before saving the plan.' });
        return;
      }
    }

    try {
      const response = await fetch(`/api/editPlan`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(editPlanData),
      });

      let payloadMessage = '';
      const contentType = response.headers.get('content-type') || '';
      if (contentType.includes('application/json')) {
        const payload = await response.json();
        payloadMessage = payload?.message || '';
      } else {
        payloadMessage = await response.text();
      }

      if (!response.ok) {
        throw new Error(payloadMessage || 'Failed to save support plan.');
      }

      // Toggle refreshData to trigger data re-fetching
      setRefreshData(prev => !prev);
      const severity = payloadMessage.toLowerCase().includes('skipped') ? 'warning' : 'success';
      setEditPlanFeedback({ severity, message: payloadMessage || 'Support plan saved successfully.' });

    } catch (error) {
      console.error('Error saving support plan:', error);
      setEditPlanFeedback({ severity: 'error', message: error.message || 'Unable to save the support plan.' });
    }
    
  };

  





  


const handleSetActionComplete = async () => {
  try {
    const today = new dayjs().format('YYYY-MM-DD'); // Format today's date as 'YYYY-MM-DD'
    console.log("today date", today);

    let updatedFormData = {
      ...editFormData, // Carry over existing data
      
    };

    if (updatedFormData.completedDate == null)
    {
      updatedFormData = {
        ...editFormData, // Carry over existing data
        completedDate: today,
      };
    }
   
    

    setEditFormData(updatedFormData); // Update the state for future renderings
    //console.log("handleSetActionComplete: ",editFormData);
    const response = await fetch(`/api/completeaction/${editFormData.actionID}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(updatedFormData)
        // body: JSON.stringify({.,
        //     eventID: editFormData.eventID, // Send the eventType ID
        //     // Include other necessary data as required
        // }),
    });
    if (!response.ok) throw new Error('Failed to link event');

    setIsDialogOpen2(false); // Close the dialog
    setRefreshData(prev => !prev); // Trigger a data refresh
  } catch (error) {
      console.error('Error linking event:', error);
  }
};

//---------------------------------------------------------------
const handleSubmitAddContact = async () => {
      
   console.log("handleSubmitAddContact" ,addContactData);
   try {
     const response = await fetch(`/api/addContact`, {
       method: 'POST',
       headers: {
         'Content-Type': 'application/json',
       },
       body: JSON.stringify(addContactData),
     });
     if (!response.ok) throw new Error('Failed to save action');
     // Toggle refreshData to trigger data re-fetching
     setRefreshData(prev => !prev);
     console.log('Contact saved successfully');
     handleAddContactClose(); // Close dialog on success
     setAddContactData({
      locationID:'',
      firstName:'',
      lastName:'',
      title:'',
      email:'',
      cell:null,
      office:null,
      ext:null,
       
   });

   } catch (error) {
     console.error('Error saving contact:', error);
   }
   
 };


 //---------------------------------------------------------------
const handleSubmitEditContact = async () => {
      
  console.log("handleSubmitEditContact" ,editContactData);
  try {
    const response = await fetch(`/api/editContact`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(editContactData),
    });
    if (!response.ok) throw new Error('Failed to save action');
    // Toggle refreshData to trigger data re-fetching
    setRefreshData(prev => !prev);
    console.log('Contact saved successfully');
    handleEditContactClose(); // Close dialog on success
    setEditContactData({
    
     locationID:'',
     firstName:'',
     lastName:'',
     title:'',
     email:'',
     cell:null,
     office:null,
     ext:null,
      
  });

  } catch (error) {
    console.error('Error saving contact:', error);
  }
  
};
//------------------------------------------------------------

const handleEditActionSaveSPlan = async () => {
  try {
     
      console.log("handleEditActionSaveSPlan",editActionDataPlan);
      const response = await fetch(`/api/updateActionSPlan/${editActionDataPlan.standardPlanID}`, {
          method: 'POST', // or 'PATCH'
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(editActionDataPlan),
          
      });
      if (!response.ok) throw new Error('Failed to update action');

      setOpenEditAction(false); // Close the dialog
      setRefreshData((prev) => !prev); // Trigger a re-fetch of the grid data
  } catch (error) {
      console.error('Error updating action:', error);
  }
};
//------------------------------------------------------------

const handleDeleteActionSaveSPlan = async () => {
  try {
     
      console.log("handleDeleteActionSaveSPlan",deleteActionSDataPlan);
      const response = await fetch(`/api/deleteActionSPlan/${deleteActionSDataPlan.standardPlanID}`, {
          method: 'POST', // or 'PATCH'
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(deleteActionSDataPlan),
          
      });
      if (!response.ok) throw new Error('Failed to update action');

      setOpenDeleteAction(false); // Close the dialog
      setRefreshData((prev) => !prev); // Trigger a re-fetch of the grid data
  } catch (error) {
      console.error('Error updating action:', error);
  }
};

//-------------------------------------------------------------
const handleSubmitNewActionSPlan = async () => {
      
  console.log("new action data SPlan" ,addActionDataSPlan);
  try {
    const response = await fetch(`/api/addActionSPlan`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(addActionDataSPlan),
    });
    if (!response.ok) throw new Error('Failed to save action');
    // Toggle refreshData to trigger data re-fetching
    setRefreshData(prev => !prev);
    console.log('Action saved successfully');
    handleNewActionDialogClose(); // Close dialog on success
    setAddActionDataSPlan({
      actionName: '',
      actionTypeID: '',
      dueDays: '',
      sortOrder: '',
      
  });


  } catch (error) {
    console.error('Error saving action:', error);
  }
  
};
//------------------------------------------------------------

const handleCreateActionType = async () => {
  setNewActionTypeFeedback({ severity: '', message: '' });

  if (!String(newActionTypeName || '').trim()) {
    setNewActionTypeFeedback({ severity: 'error', message: 'Enter an action type name.' });
    return;
  }

  try {
    const response = await fetch(`/api/action-types`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ name: newActionTypeName.trim() }),
    });

    const contentType = response.headers.get('content-type') || '';
    let payload = {};
    if (contentType.includes('application/json')) {
      payload = await response.json();
    } else {
      payload = { message: await response.text() };
    }

    if (!response.ok) {
      throw new Error(payload?.message || 'Unable to create action type.');
    }

    const createdType = {
      ActionTypeID: payload.ActionTypeID,
      ActionTypeName: payload.ActionTypeName,
    };

    if (createdType.ActionTypeID && createdType.ActionTypeName) {
      setActionTypeData((prevState) => {
        const next = [...prevState.filter((item) => item.ActionTypeID !== createdType.ActionTypeID), createdType];
        return next.sort((a, b) => String(a.ActionTypeName).localeCompare(String(b.ActionTypeName)));
      });

      const createdId = createdType.ActionTypeID;
      if (actionTypeDialogTarget === 'standard-new') {
        setAddActionDataSPlan((prevState) => ({ ...prevState, actionTypeID: createdId }));
      } else if (actionTypeDialogTarget === 'premium-new') {
        setAddActionDataPPlan((prevState) => ({ ...prevState, actionTypeID: createdId }));
      } else if (actionTypeDialogTarget === 'standard-edit' || actionTypeDialogTarget === 'premium-edit') {
        setEditActionDataPlan((prevState) => ({ ...prevState, actionTypeID: createdId }));
      }
    }

    setNewActionTypeFeedback({ severity: 'success', message: payload?.message || 'Action type created successfully.' });
  } catch (error) {
    console.error('Error creating action type:', error);
    setNewActionTypeFeedback({ severity: 'error', message: error.message || 'Unable to create action type.' });
  }
};

//------------------------------------------------------------

//------------------------------------------------------------

const handleEditActionSavePPlan = async () => {
  try {
     
      console.log("handleEditActionSavePPlan",editActionDataPlan);
      const response = await fetch(`/api/updateActionPPlan/${editActionDataPlan.premiumPlanID}`, {
          method: 'POST', // or 'PATCH'
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(editActionDataPlan),
          
      });
      if (!response.ok) throw new Error('Failed to update action');

      setOpenEditAction2(false); // Close the dialog
      setRefreshData((prev) => !prev); // Trigger a re-fetch of the grid data
  } catch (error) {
      console.error('Error updating action:', error);
  }
};
//------------------------------------------------------------

const handleDeleteActionSavePPlan = async () => {
  try {
     
      console.log("handleDeleteActionSavePPlan",deleteActionPDataPlan);
      const response = await fetch(`/api/deleteActionPPlan/${deleteActionPDataPlan.premiumPlanID}`, {
          method: 'POST', // or 'PATCH'
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(deleteActionPDataPlan),
          
      });
      if (!response.ok) throw new Error('Failed to update action');

      setOpenDeleteAction2(false); // Close the dialog
      setRefreshData((prev) => !prev); // Trigger a re-fetch of the grid data
  } catch (error) {
      console.error('Error updating action:', error);
  }
};

//-------------------------------------------------------------
const handleSubmitNewActionPPlan = async () => {
      
  console.log("new action data PPlan" ,addActionDataPPlan);
  try {
    const response = await fetch(`/api/addActionPPlan`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(addActionDataPPlan),
    });
    if (!response.ok) throw new Error('Failed to save action');
    // Toggle refreshData to trigger data re-fetching
    setRefreshData(prev => !prev);
    console.log('Action saved successfully');
    handleNewActionDialogClose2(); // Close dialog on success
    setAddActionDataPPlan({
      actionName: '',
      actionTypeID: '',
      dueDays: '',
      sortOrder: '',
      
  });


  } catch (error) {
    console.error('Error saving action:', error);
  }
  
};


//------------------------------------------------------------

const handleDeleteAction2 = async () => {
  try {
     
      console.log("handleDeleteAction",deleteAction);
      const response = await fetch(`/api/deleteAction/${deleteAction.ActionID}`, {
          method: 'POST', // or 'PATCH'
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(deleteAction),
          
      });
      if (!response.ok) throw new Error('Failed to update action');

      setOpenDeleteAction3(false); // Close the dialog
      setRefreshData((prev) => !prev); // Trigger a re-fetch of the grid data
  } catch (error) {
      console.error('Error updating action:', error);
  }
};
//------------------------------------------------------------

//------------------------------------------------------HTML------------------------------------------------------------------------------
//------------------------------------------------------HTML------------------------------------------------------------------------------ 
//------------------------------------------------------HTML------------------------------------------------------------------------------
//------------------------------------------------------HTML------------------------------------------------------------------------------
//------------------------------------------------------HTML------------------------------------------------------------------------------
  return (
  <>
      <aside className={`${styles.actions} ${styles[theme]}`}>
      {/* ---------------------TOP MENU --------------------------------   
      -------------------------TOP MENU --------------------------------  
      -------------------------TOP MENU --------------------------------     */}
      <div style={{ display: 'flex', flexDirection: 'row', gap: '0px' }}>
            <Card className={`${styles.card} ${styles[theme]}`} sx={{ width: 520 }}>
              <CardContent>
              <Typography sx={{ fontSize: 12, paddingBottom:'10px' }} gutterBottom>
              <span className={`${styles[theme]}Text`}>Select Company and Location</span>
                  </Typography>
                 
                <Box sx={{ display: 'flex', gap: 2 }}>
                <FormControl sx={{ minWidth: 220 }} size="small">
                <InputLabel className={`${styles.select} ${styles[theme]}`} id="main-company-label">Company</InputLabel>
                <Select className={`${styles.select} ${styles[theme]}`} sx={{
                    fontFamily: 'Merriweather, serif',
                    fontWeight: '200',
                    fontStyle: 'italic'
                  }}
                  labelId="main-company-label"
                  id="main-company-select"
                  value={selectedCompanyName}
                  label="Company"
                  onChange={handleChangeMainCompany}
                >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {companyOptions.map((companyName) => (
                <MenuItem sx={{
                  fontFamily: 'Merriweather, serif',
                  fontWeight: '200',
                  fontStyle: 'italic'
                }} key={companyName} value={companyName}>
                {companyName}
              </MenuItem>
                ))}
                </Select>
              </FormControl>
                <FormControl sx={{ minWidth: 220 }} size="small" disabled={!selectedCompanyName}>
                <InputLabel className={`${styles.select} ${styles[theme]}`} id="main-location-label">Location</InputLabel>
                <Select className={`${styles.select} ${styles[theme]}`} sx={{
                    fontFamily: 'Merriweather, serif',
                    fontWeight: '200',
                    fontStyle: 'italic'
                  }}
                  labelId="main-location-label"
                  id="main-location-select"
                  value={company}
                  label="Location"
                  onChange={handleChangeMainLocation}
                >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {filteredMainLocations.map((location) => (
                <MenuItem sx={{
                  fontFamily: 'Merriweather, serif',
                  fontWeight: '200',
                  fontStyle: 'italic'
                }} key={getLocationId(location)} value={String(getLocationId(location))}>
                {getDivisionName(location) || getLocationLabel(location)}
              </MenuItem>
                ))}
                </Select>
              </FormControl>
              </Box>
             </CardContent>
            </Card>




            <Card className={`${styles.card} ${styles[theme]}`}sx={{ width: 680 }}>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <CardContent>
                <Typography sx={{ fontSize: 12 }}  gutterBottom>
                <span className={`${styles[theme]}Text`}>{selectedCompanyObj ? `${selectedCompanyObj.CompanyAndDivision} is enrolled in` : "Please select a company"}</span>
                 
                  </Typography>
                  {/* <Divider sx={{ marginLeft: '10px', borderColor: 'primary.main', height:'50px'  }} orientation="vertical" variant="middle" flexItem  /> */}
                  <Typography variant="h5" component="div" sx={{
                    fontFamily: 'DM Serif Display, serif',
                    fontWeight: '350',
                    fontStyle: 'italic'
                  }}>
                  {selectedCompanyObj ? getSupportStatusText(selectedCompanyObj.SupportStatus) : ''}
                  </Typography>
                  <Rating
                    name="customized-rating"
                    value={selectedCompanyObj ? (selectedCompanyObj.SupportStatus) : 0} // The current value of the rating
                    max={3} // Set the maximum number of stars to 3
                    readOnly={true} // Set to true if you do not need it to be interactive
                  />
               </CardContent>
               <div >
               <CardContent>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between'  }}>
                  <div>
                  <Typography sx={{ fontSize: 12 }}  gutterBottom>
                  <span className={`${styles[theme]}Text`}>Start Date </span>
                  </Typography>
                  <Typography variant="subtitle2" component="div" >
                  {selectedCompanyObj && selectedCompanyObj.SupportStartDate ? selectedCompanyObj.SupportStartDate.split('T')[0] : 'N/A'}
                  </Typography>  
                  </div>
                  <Divider  orientation="vertical" flexItem sx={{  backgroundColor: 'grey', marginLeft:'5px' , marginRight:'5px'}}  />
                  <div>
                    <Typography sx={{ fontSize: 12 }}  gutterBottom>
                    <span className={`${styles[theme]}Text`}>End Date </span>
                    </Typography>
                    <Typography variant="subtitle2" component="div" >
                    {selectedCompanyObj && selectedCompanyObj.SupportEndDate ? selectedCompanyObj.SupportEndDate.split('T')[0] : 'N/A'}

                    </Typography>  
                  </div>
                </div>
                </CardContent>
                <Typography style={{ marginLeft:'35px', paddingRight:'5px', fontSize:'.7rem' }} variant="overline" display="block" gutterBottom>
                  Remaining Days : {selectedCompanyObj && selectedCompanyObj.SupportEndDate ? calculateRemainingDays(selectedCompanyObj.SupportEndDate) : 'No End Date'} 
                </Typography>
               
                </div>
              </div>
             </Card>


             <Card className={`${styles.card} ${styles[theme]}`} sx={{ width: 400 }}>
              <CardContent>
                <Typography sx={{ fontSize: 12, paddingBottom:'10px' }} gutterBottom>
                <span className={`${styles[theme]}Text`}>Customer Information</span>
                </Typography>
               
                  <Box sx={{paddingBottom:'10px'}}>
                    <Typography variant="body2">Contact 1: {customerInfo[0] ? customerInfo[0].FirstName + ' ' + customerInfo[0].LastName + ' (' + customerInfo[0].Title + ')' : ''}</Typography>
                    <Typography variant="body2">Contact 2: {customerInfo[1] ? customerInfo[1].FirstName + ' ' + customerInfo[1].LastName + ' (' + customerInfo[1].Title + ')' : ''}</Typography>
                    
                   
                  </Box>
               
                 
                
             </CardContent>
            </Card>

             





             <Card className={`${styles.card} ${styles[theme]}`}sx={{ width: 300 }}> 
             <CardContent>
             <Typography sx={{ fontSize: 12, paddingBottom:'10px' }} gutterBottom>
                <span className={`${styles[theme]}Text`}>Action Progress</span>
                </Typography>
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Box>
                  <Typography variant="subtitle2">Total Actions: {totalActions}</Typography>
                  <Typography variant="subtitle2">Completed Actions: {completedActions}</Typography>
                </Box>
                <Box position="relative" display="inline-flex">
                  {/* Background progress (incomplete portion) */}
                  <CircularProgress
                    variant="determinate"
                    value={100}  // Always full to represent the total
                    size={50}
                    thickness={4}
                    sx={{ color: '#dcdcdc' }} // Color for the incomplete portion
                  />
                  {/* Foreground progress (completed portion) */}
                  <CircularProgress
                    variant="determinate"
                    value={completionPercentage}
                    size={50}
                    thickness={4}
                    sx={{ color: '#ff6c5c', position: 'absolute', left: 0 }} // Color for the completed portion
                  />
                  <Box
                    top={0}
                    left={0}
                    bottom={0}
                    right={0}
                    position="absolute"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Typography variant="caption" component="div"   className={`${styles[theme]}Text`} sx={{fontSize: '0.9rem' }}>
                      {`${Math.round(completionPercentage)}%`}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              </CardContent>
             </Card>

            </div>





          <Divider orientation="horizontal"  />



      {/* ---------------------TABLE  --------------------------------   
      -------------------------TABLE  --------------------------------  
      -------------------------TABLE  --------------------------------     */}   

          <Box className={`  ${styles[theme]}`} sx={{display: 'flex',flexDirection: 'row',width: '100%'}}>
               {/* BOX1 */}
              <Box className={` ${styles[theme]}`} sx={{m:1,width:'100%'}}>
                <Paper elevation={1}> 
                
                <Box className={`${styles.box} ${styles[theme]}`}
                    sx={{
                      display: 'flex', // Use flex display
                      justifyContent: 'center', // Center the content horizontally
                      alignItems: 'center', // Align items vertically in the center
                      paddingTop: '8px', // Optional padding at the top
                      paddingBottom: '8px', // Optional padding at the bottom
                    }}
                  >
                    {/* Typography for "Actions" text */}
                    <Typography 
                      sx={{
                        fontFamily: 'DM Serif Display, serif',
                        fontWeight: '400',
                        fontStyle: 'normal',
                        textAlign: 'center',
                        flexGrow: 1, // Allows the text to grow and push the icon to the right
                      }}
                      variant="h6"
                      gutterBottom
                    >
                     {selectedCompanyObj ? selectedCompanyObj.CompanyAndDivision : ''}  Actions
                    </Typography>
                    <FormControlLabel 
                          control={
                            <GreenSwitch 
                              checked={showCompleted}
                              onChange={(event) => setShowCompleted(event.target.checked)} 
                              
                            />
                          } 
                          label="Show Completed Actions" 
                        />
                     {/* IconButton wrapping the IoMdAddCircle icon */}
                    <Button onClick={handleClickOpen} aria-label="add">
                      <MdOutlineLibraryAdd style={{ fontSize: '30px', float: 'right' }} />
                    </Button>
                    
                   


                 


                  </Box>
               
                </Paper> 
                
                
                

                  {/* TABLE DATA* */}
                  {/* TABLE DATA*/}
                  {/* TABLE DATA**/}


                  <style>
                    {`
                      .light-theme .my-datagrid .MuiDataGrid-root .MuiDataGrid-cell,
                      .light-theme .my-datagrid .MuiDataGrid-root .MuiDataGrid-columnHeader {
                        background-color: #f0f0f0; /* Light theme background color */
                        color: #000000; /* Light theme text color */
                        font-weight: bold; /* Makes the font bold */
                      }
                  
                      .light-theme .my-datagrid .MuiDataGrid-columnHeaderTitleContainer {
                        background-color: inherit; /* Ensure the background color fills the whole header */
                      }
                      /* Dark theme styles */
                      .dark-theme .MuiDataGrid-root {
                        border-color: #2c2c2b; /* Dark theme border color */
                      }
                      .dark-theme .my-datagrid .MuiDataGrid-columnHeaders,
                      .dark-theme .my-datagrid .MuiDataGrid-cell,
                      .dark-theme .my-datagrid .MuiTablePagination-root,
                      .dark-theme .my-datagrid .MuiDataGrid-withBorderColor,
                      .dark-theme .my-datagrid .MuiDataGrid-root,
                      .dark-theme .MuiTypography-root,
                      .dark-theme .MuiButtonBase-root.MuiIconButton-root,
                      .dark-theme .my-datagrid .MuiDataGrid-columnHeaderTitle {
                        background-color: ##000; /* Dark theme background color */
                        color: #D8D8D8; /* Dark theme text color */
                        border-color: #2c2c2b;
                         /* Makes the font bold */
                      }
                      .dark-theme .my-datagrid .MuiTablePagination-root .MuiTablePagination-caption,
                      .dark-theme .my-datagrid .MuiTablePagination-root .MuiTablePagination-toolbar,
                      .dark-theme .my-datagrid .MuiTablePagination-root .MuiIconButton-label,
                      .dark-theme .my-datagrid .MuiButtonBase-root.MuiIconButton-root.Mui-disabled
                      {
                        color: #ffffff; /* Dark theme pagination text color */
                       
                      .dark-theme .my-datagrid .MuiDataGrid-columnHeaderTitleContainer {
                        background-color: inherit; /* Ensure the background color fills the whole header */
                      }

                   
                  
                      
                      
                      
                    `}
                    </style>

                <TableContainer  className={`${styles[theme]} ${theme === 'light' ? 'light-theme' : 'dark-theme'}`}  style={{ height: '74vh', overflowY: 'auto' }}  >
                {/* <div style={{ height: '85vh', width: '100%' }}> */}
                  <DataGrid
                  className="my-datagrid"
                    rows={filteredActionData}
                    columns={columns}
                    initialState={{
                      pagination: {
                        paginationModel: { page: 0, pageSize: 15 },
                      },
                    }}
                    pageSizeOptions={[5, 10]}
                    //checkboxSelection
                  />
                </TableContainer>
              </Box>
            </Box> 

                  {/* DIALOG1 */}
                  {/* NEW ACTION */}
                  {/* DIALOG1 */}


                  <Dialog className={`${styles[theme]}`}
                                      PaperProps={{
                                        className: theme === 'light' ? styles['light-dialogPaper'] : styles['dark-dialogPaper'],
                                      }} open={open} onClose={handleClose} maxWidth="md" sx={{  width: '100%'}}>
                      <DialogTitle 
                      >NEW ACTION
                      <MdOutlineLibraryAdd style={{ fontSize: '30px', float: 'right' }} />
                      </DialogTitle>
                      <br></br>
                      <DialogContent >
                      <Box sx={{display: 'flex',flexDirection: 'row'}}>
                      <TextField 
                       InputProps={{readOnly: true,
                        style: {
                          color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                          borderColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                        }}}
                        sx={{
                          '& .MuiFormHelperText-root': {
                            color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                          },
                        
                        }}
                       helperText="Location cannot be changed." label="LOCATION"  color="success" focused defaultValue={selectedCompanyObj ? `${selectedCompanyObj.CompanyAndDivision} ` : ""} />
                      <TextField
                      InputProps={{
                          style: {
                          color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                          borderColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                        }
                      }}
                      InputLabelProps={{
                        style: {
                          color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                          
                        }
                      }}
                            id="sortOrder"
                            label="Sort Order"
                            type="number"
                            variant='outlined'
                            value={formData.sortOrder}
                            onChange={(e) => handleChangeNewAction('sortOrder', e.target.value)}
                            sx={{  width:'150px', marginTop:'0px', marginLeft:'130px' }}
                          
                          />
                      </Box>
                      <br></br>
                      <div sx={{display: 'flex',flexDirection: 'row'}}>
                           {/* Action Name */}
                        <TextField
                        InputProps={{
                          style: {
                          color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                          borderColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                        }
                      }}
                      InputLabelProps={{
                        style: {
                          color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                          
                        }
                      }}
                          autoFocus
                          margin="dense"
                          id="action-name"
                          label="Action Name"
                          type="text"
                          variant="outlined"
                          value={formData.actionName}
                          onChange={(e) => handleChangeNewAction('actionName', e.target.value)}
                          sx={{  width:'300px' }}
                        />

                        {/* Action Type Dropdown */}
                        <FormControl   margin="dense" sx={{ marginLeft:'10px', width:'200px' }}>
                          <InputLabel className={theme === 'light' ? styles.lightLabel : styles.darkLabel} id="action-type-label">Action Type</InputLabel>
                          <Select
                          className={theme === 'light' ? styles.lightSelect : styles.darkSelect}
                            labelId="action-type-label"
                            id="action-type-select"
                            value={formData.actionType}
                            label="Action Type"
                            onChange={(e) => handleChangeNewAction('actionType', e.target.value)}
                          >
                             {actionTypeData.map((type) => (
                              <MenuItem key={type.ActionTypeID} value={type.ActionTypeID}>
                                {type.ActionTypeName}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>

                      </div>
                       
                      <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                        {/* Employee Dropdown */}
                        <FormControl  margin="dense" sx={{  width:'300px' }}>
                          <InputLabel className={theme === 'light' ? styles.lightLabel : styles.darkLabel} id="employee-label">Assign SiCam Employee</InputLabel>
                          <Select
                          className={theme === 'light' ? styles.lightSelect : styles.darkSelect}
                            labelId="employee-label"
                            id="employee-select"
                            value={formData.actionEmployee}
                            label="Assign SiCam Employee"
                            onChange={(e) => handleChangeNewAction('actionEmployee', e.target.value)}
                          >
                            {employeeData.map((type) => (
                              <MenuItem key={type.EmployeeID} value={type.EmployeeID}>
                                {type.EmployeeName}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>

                        
                        <LocalizationProvider dateAdapter={AdapterDayjs} >
                          <DemoContainer components={['DatePicker']} sx={{  marginLeft:'10px', width:'200px' }}>
                            <DatePicker label="Due Date" 
                            value={formData.date ? dayjs(formData.date) : null} 
                            onChange={(newValue) => handleChangeNewAction('dueDate', newValue)}
                            renderInput={(params) => <TextField {...params} />}
                            sx={{
                              '& .MuiInputLabel-root': {
                                color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                              },
                              '& .MuiInputBase-input': {
                                color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                              },
                              '& .MuiInput-underline:before, & .MuiInput-underline:after': {
                                borderBottomColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                              },
                              '& .MuiIconButton-root': {
                                color: theme === 'light' ? '#000000' : 'rgba(176, 185, 193, 0.98)',
                              },
                              
                            }}
                            />
                            
                          </DemoContainer>
                        </LocalizationProvider>
                        </Box>
                        <FormControlLabel
                        sx={{
                          '& .MuiFormControlLabel-label': {
                            color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                          },
                        
                        }}
                                  control={
                                      <Switch
                                          checked={isActionCompleted}
                                          onChange={handleSwitchChangeActionCompleted}
                                          
                                      />
                                  }
                                  label="Action Completed"
                        />
                        <Box sx={{display: 'flex',flexDirection: 'row'}}>
                        <FormControl  margin="dense" sx={{  width:'300px' }}>
                          <InputLabel className={theme === 'light' ? styles.lightLabel : styles.darkLabel}id="employee-label">Completed By</InputLabel>
                          <Select
                          className={theme === 'light' ? styles.lightSelect : styles.darkSelect}
                            labelId="completedEmployee-label"
                            id="completedEmployee-select"
                            value={formData.completedEmployee}
                            label="Completed By"
                            onChange={(e) => handleChangeNewAction('completedEmployee', e.target.value)}
                          >
                            {employeeData.map((type) => (
                              <MenuItem key={type.EmployeeID} value={type.EmployeeID}>
                                {type.EmployeeName}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        <div>
                        <LocalizationProvider dateAdapter={AdapterDayjs} >
                          <DemoContainer components={['DatePicker']} sx={{  marginLeft:'10px', width:'200px' }}>
                            <DatePicker label="Completed Date" 
                            value={formData.completedDate ? dayjs(formData.completedDate) : null} 
                            onChange={(newValue) => handleChangeNewAction('completedDate', newValue)}
                            renderInput={(params) => <TextField {...params} />}
                            sx={{
                              '& .MuiInputLabel-root': {
                                color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                              },
                              '& .MuiInputBase-input': {
                                color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                              },
                              '& .MuiInput-underline:before, & .MuiInput-underline:after': {
                                borderBottomColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                              },
                              '& .MuiIconButton-root': {
                                color: theme === 'light' ? '#000000' : 'rgba(176, 185, 193, 0.98)',
                              },
                            }}
                            />
                            
                          </DemoContainer>
                        </LocalizationProvider>
                        </div>

                        </Box>
                        
                      </DialogContent>
                      <DialogActions sx={{ marginRight:'20px'}}>
                      
                        <Button variant="contained" color="error" onClick={handleClose}>Cancel</Button>
                        <Button variant="contained" color="success" disabled={isActionCompleted && ( !formData.completedEmployee || !formData.completedDate)} onClick={handleSubmitNewAction}>Save</Button>
                      </DialogActions>
                      
                    </Dialog>







                  {/* DIALOG2 */}
                  {/* EDIT ACTION */}
                  {/* DIALOG2 */}


                    <Dialog className={`${styles[theme]}`}
                                      PaperProps={{
                                        className: theme === 'light' ? styles['light-dialogPaper'] : styles['dark-dialogPaper'],
                                      }} open={isDialogOpen} onClose={() => setIsDialogOpen(false)} maxWidth="md" fullWidth>
                      <DialogTitle>EDIT ACTION
                      <MdOutlineLibraryAdd style={{ fontSize: '30px', float: 'right' }} />
                      </DialogTitle>
                      <br></br>
                      <DialogContent>
                      <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                      <TextField InputProps={{readOnly: true,
                        style: {
                          color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                          borderColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                        }}}
                        sx={{
                          '& .MuiFormHelperText-root': {
                            color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                          },
                        
                        }} helperText="Location cannot be changed." label="LOCATION"  color="success" focused defaultValue={selectedCompanyObj ? `${selectedCompanyObj.CompanyAndDivision} ` : ""}/>
                      <TextField
                      InputProps={{
                        style: {
                        color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                        borderColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                      }
                    }}
                    InputLabelProps={{
                      style: {
                        color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                        
                      }
                    }}
                            id="sortOrder"
                            label="Sort Order"
                            type="number"
                            variant='outlined'
                            value={editFormData.sortOrder}
                            onChange={(e) => handleChangeEditAction('sortOrder', e.target.value)}
                            sx={{  width:'150px', marginTop:'0px', marginLeft:'130px' }}
                          />
                      
                      </Box>
                      <br></br>
                      <div sx={{display: 'flex',flexDirection: 'row'}}>
                           {/* Action Name */}
                        <TextField
                          InputProps={{
                            style: {
                            color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                            borderColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                          }
                        }}
                        InputLabelProps={{
                          style: {
                            color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                            
                          }
                        }}
                          autoFocus
                          margin="dense"
                          id="action-name"
                          label="Action Name"
                          type="text"
                          variant="outlined"
                          value={editFormData.actionName || ''}
                          onChange={(e) => handleChangeEditAction('actionName', e)}  // 'e' is the event
                          sx={{  width:'300px' }}
                        />

                        {/* Action Type Dropdown */}
                        <FormControl  margin="dense" sx={{ marginLeft:'10px', width:'200px' }}>
                          <InputLabel className={theme === 'light' ? styles.lightLabel : styles.darkLabel} id="action-type-label">Action Type</InputLabel>
                          <Select
                           className={theme === 'light' ? styles.lightSelect : styles.darkSelect}
                            labelId="action-type-label"
                            id="action-type-select"
                            value={editFormData.actionType}
                            label="Action Type"
                            onChange={(e) => handleChangeEditAction('actionType', e.target.value)}
                          >
                             {actionTypeData.map((type) => (
                              <MenuItem key={type.ActionTypeID} value={type.ActionTypeID}>
                                {type.ActionTypeName}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>

                      </div>
                       
                      <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                        {/* Employee Dropdown */}
                        <FormControl  margin="dense" sx={{  width:'300px' }}>
                          <InputLabel  className={theme === 'light' ? styles.lightLabel : styles.darkLabel}  id="employee-label">Assign SiCam Employee</InputLabel>
                          <Select
                           className={theme === 'light' ? styles.lightSelect : styles.darkSelect}
                            labelId="employee-label"
                            id="employee-select"
                            value={editFormData.actionEmployee}
                            label="Assign SiCam Employee"
                            onChange={(e) => handleChangeEditAction('actionEmployee', e.target.value)}
                          >
                            {employeeData.map((type) => (
                              <MenuItem key={type.EmployeeID} value={type.EmployeeID}>
                                {type.EmployeeName}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>

                        
                        <LocalizationProvider dateAdapter={AdapterDayjs} >
                          <DemoContainer components={['DatePicker']} sx={{  marginLeft:'10px', width:'200px' }}>
                            <DatePicker label="Due Date" 
                            value={editFormData.dueDate}
                            onChange={(newValue) => handleChangeEditAction('dueDate', newValue)}
                            renderInput={(params) => <TextField {...params} />}
                            sx={{
                              '& .MuiInputLabel-root': {
                                color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                              },
                              '& .MuiInputBase-input': {
                                color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                              },
                              '& .MuiInput-underline:before, & .MuiInput-underline:after': {
                                borderBottomColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                              },
                              '& .MuiIconButton-root': {
                                color: theme === 'light' ? '#000000' : 'rgba(176, 185, 193, 0.98)',
                              },
                              
                            }}
                            />
                            
                          </DemoContainer>
                        </LocalizationProvider>
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                                  {editFormData.completedDate && (
                                    <FormControl margin="dense" sx={{ width: '300px' }}>
                                      <InputLabel id="employee-label">Completed By</InputLabel>
                                      <Select
                                        labelId="completedEmployee-label"
                                        id="completedEmployee-select"
                                        value={editFormData.completedEmployee}
                                        label="Completed By"
                                        onChange={(e) => handleChangeEditAction('completedEmployee', e.target.value)}
                                      >
                                        {employeeData.map((type) => (
                                          <MenuItem key={type.EmployeeID} value={type.EmployeeID}>
                                            {type.EmployeeName}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    </FormControl>
                                  )}

                                  {editFormData.completedDate && (
                                    <div>
                                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DemoContainer components={['DatePicker']} sx={{ marginLeft: '10px', width: '200px' }}>
                                          <DatePicker
                                            label="Completed Date"
                                            value={editFormData.completedDate ? dayjs(editFormData.completedDate) : null}
                                            onChange={(newValue) => handleChangeEditAction('completedDate', newValue)}
                                            renderInput={(params) => <TextField {...params} />}
                                          />
                                        </DemoContainer>
                                      </LocalizationProvider>
                                    </div>
                                  )}
                                </Box>
                       
                      </DialogContent>
                      <DialogActions sx={{ marginRight:'20px' }}>
                      
                        <Button variant="contained" color="error" onClick={() => setIsDialogOpen(false)}>Cancel</Button>
                        <Button variant="contained" color="success" onClick={handleEditActionSave}>Save</Button>
                      </DialogActions>
                      
                    </Dialog>









                  {/* DIALOG3 */}
                  {/* COMPLETE ACTION */}
                  {/* DIALOG3 */}
                    <Dialog className={`${styles[theme]}`}
                                      PaperProps={{
                                        className: theme === 'light' ? styles['light-dialogPaper'] : styles['dark-dialogPaper'],
                                      }} open={isDialogOpen2} onClose={() => setIsDialogOpen2(false)} maxWidth="sm" fullWidth>
                      <DialogTitle>COMPLETE ACTION
                      <MdOutlineLibraryAddCheck  style={{ fontSize: '40px', float: 'right' }} />
                      
                      </DialogTitle>
                      <br></br>
                      <DialogContent>
                      
                          <TextField  InputProps={{readOnly: true,
                        style: {
                          color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                          borderColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                        }}}
                        sx={{
                          '& .MuiFormHelperText-root': {
                            color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                          },
                        
                        }} helperText="Location cannot be changed here." label="LOCATION"  color="success" focused defaultValue={selectedCompanyObj ? `${selectedCompanyObj.CompanyAndDivision} ` : ""}/>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>                           
                            <TextField 
                               InputProps={{readOnly: true,
                                style: {
                                color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                                borderColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                              }
                            }}
                           
                            InputLabelProps={{
                              style: {
                                color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                                
                              }
                            }}
                            
                                autoFocus
                                margin="dense"
                                id="action-name"
                                label="Action Name"
                                type="text"
                                variant="outlined"
                                value={editFormData.actionName || ''}
                                helperText="Action cannot be changed here."
                                sx={{  width:'600px', '& .MuiFormHelperText-root': {
                                  color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                                },  }}
                              />

                          </Box>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}> 

                          <FormControl  margin="dense" sx={{  width:'300px', marginBottom:'0px', paddingTop: '10px' }}>
                          <InputLabel  className={theme === 'light' ? styles.lightLabel : styles.darkLabel} id="employee-label2">Completed By</InputLabel>
                          <Select
                          className={theme === 'light' ? styles.lightSelect : styles.darkSelect}
                            labelId="employee-label2"
                            id="employee-select2"
                            label="Completed By"
                            onChange={(e) => handleChangeEditAction('completedEmployee', e.target.value)}
                          >
                            {employeeData.map((type) => (
                              <MenuItem key={type.EmployeeID} value={type.EmployeeID}>
                                {type.EmployeeName}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DemoContainer components={['DatePicker']} sx={{ marginLeft: '0px', marginTop: '10px', paddingTop: '5px', width: '300px' }}>
                                <DatePicker
                                  label="Completed Date"
                                  value={editFormData.completedDate ? dayjs(editFormData.completedDate) : dayjs()}
                                  onChange={(newValue) => handleChangeEditAction('completedDate', newValue)}
                                  renderInput={(params) => <TextField {...params} />}
                                  sx={{
                                    '& .MuiInputLabel-root': {
                                      color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                                    },
                                    '& .MuiInputBase-input': {
                                      color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                                    },
                                    '& .MuiInput-underline:before, & .MuiInput-underline:after': {
                                      borderBottomColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                                    },
                                    '& .MuiIconButton-root': {
                                      color: theme === 'light' ? '#000000' : 'rgba(176, 185, 193, 0.98)',
                                    },
                                    
                                  }}
                                />
                              </DemoContainer>
                            </LocalizationProvider>
                          
                        </Box>
 
                        
                
                        
                       
                      </DialogContent>
                      <DialogActions sx={{ marginRight:'20px' }}>
                      
                        <Button variant="contained" color="error" onClick={() => setIsDialogOpen2(false)}>Cancel</Button>
                        <Button variant="contained" color="success" onClick={handleSetActionComplete}><IoCheckmarkOutline style={{ fontSize: '20px' }} /> &nbsp;Complete</Button>
                      </DialogActions>
                      
                    </Dialog>




            {/* DIALOG4 */}
            {/* ADD NEW LOCATION */}
            {/* DIALOG4 */}

            <Dialog className={`${styles[theme]}`}
                                      PaperProps={{
                                        className: theme === 'light' ? styles['light-dialogPaper'] : styles['dark-dialogPaper'],
                                      }} open={addLocationOpen} onClose={() => setAddLocationOpen(false)} maxWidth="md" >
            
              <DialogTitle>ADD NEW LOCATION 
              <MdAddLocationAlt style={{ fontSize: '50px', float: 'right', margin:'0px' }} />
                      
              </DialogTitle>
                <br></br>
              <DialogContent>
              {addLocationFeedback.message ? (
                <Alert severity={addLocationFeedback.severity || 'info'} sx={{ mb: 2 }}>
                  {addLocationFeedback.message}
                </Alert>
              ) : null}
              <div sx={{display: 'flex',flexDirection: 'row'}}>
              <FormControl component="fieldset">
              <FormControlLabel 
                control={ 
                
                    <Switch
                        checked={isCompanySwitchOn}
                        onChange={handleSwitchNewCompany}
                    />
                  }
                  label="Create New Company" // Change the label text as needed
              />
                    {isCompanySwitchOn ? (
                        <TextField
                        InputProps={{
                          style: {
                          color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                          borderColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                        }
                      }}
                      InputLabelProps={{
                        style: {
                          color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                          
                        }
                      }}
                            label="Enter Company Name"
                            variant="outlined"
                            value={addLocationData.companyName || ''}
                            sx={{  width:'300px'}}
                            onChange={(e) => handleChangeAddLocation('companyName', e.target.value)}
                            fullWidth
                        />
                    ) : (
                        <FormControl fullWidth>
                            <InputLabel className={theme === 'light' ? styles.lightLabel : styles.darkLabel} id="demo-simple-select-label">Select Company</InputLabel>
                            <Select
                             className={theme === 'light' ? styles.lightSelect : styles.darkSelect}
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                sx={{  width:'300px'}}
                                label="Select Company"
                                value={addLocationData.companyID || ''}
                                onChange={(e) => handleChangeAddLocation('companyID', e.target.value)}
                            >
                                {companyData.map((type) => (
                              <MenuItem key={type.CompanyID} value={type.CompanyID}>
                                {type.CompanyName}
                              </MenuItem>
                            ))}
                            </Select>
                        </FormControl>
                    )}
                </FormControl>

                <TextField
                InputProps={{
                  style: {
                  color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                  borderColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                }
              }}
              InputLabelProps={{
                style: {
                  color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                  
                }
              }}
                          autoFocus
                          margin="dense"
                          id="division-name"
                          label="Enter Division Name"
                          type="text"
                          variant="outlined"
                          value={addLocationData.divisionName || ''}
                          onChange={(e) => handleChangeAddLocation('divisionName', e.target.value)}
                          sx={{  width:'300px', marginTop:'38px', marginLeft:'10px' }}
                        />
                </div>
                <div sx={{display:'flex'}}>
                      <TextField
                      InputProps={{
                        style: {
                        color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                        borderColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                      }
                    }}
                    InputLabelProps={{
                      style: {
                        color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                        
                      }
                    }}
                        id="address"
                        label="Address"
                        type="text"
                        variant='outlined'
                        onChange={(e) => handleChangeAddLocation('address', e.target.value)}
                        sx={{  width:'300px', marginTop:'10px' }}
                        />
                        <TextField
                        InputProps={{
                          style: {
                          color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                          borderColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                        }
                      }}
                      InputLabelProps={{
                        style: {
                          color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                          
                        }
                      }}
                        id="postal"
                        label="Postal Code"
                        type="text"
                        variant='outlined'
                        onChange={(e) => handleChangeAddLocation('postal', e.target.value)}
                        sx={{  width:'120px', marginTop:'10px', marginLeft:'10px' }}
                        />
                        <TextField
                        InputProps={{
                          style: {
                          color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                          borderColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                        }
                      }}
                      InputLabelProps={{
                        style: {
                          color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                          
                        }
                      }}
                        id="city"
                        label="City"
                        type="text"
                        variant='outlined'
                        onChange={(e) => handleChangeAddLocation('city', e.target.value)}
                        sx={{  width:'170px', marginTop:'10px', marginLeft:'10px' }}
                        />
                        <TextField
                        InputProps={{
                          style: {
                          color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                          borderColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                        }
                      }}
                      InputLabelProps={{
                        style: {
                          color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                          
                        }
                      }}
                        id="state"
                        label="State"
                        type="text"
                        variant='outlined'
                        onChange={(e) => handleChangeAddLocation('state', e.target.value)}
                        sx={{  width:'300px', marginTop:'10px' }}
                        />
                        <TextField
                        InputProps={{
                          style: {
                          color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                          borderColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                        }
                      }}
                      InputLabelProps={{
                        style: {
                          color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                          
                        }
                      }}
                        id="country"
                        label="Country"
                        type="text"
                        variant='outlined'
                        onChange={(e) => handleChangeAddLocation('country', e.target.value)}
                        sx={{  width:'300px', marginTop:'10px', marginLeft:'10px' }}
                        />
                </div>
                <div sx={{display:'flex'}}>
                <TextField
                        InputProps={{
                          style: {
                          color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                          borderColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                        }
                      }}
                      InputLabelProps={{
                        style: {
                          color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                          
                        }
                      }}
                        id="latitude"
                        label="Latitude"
                        type="text"
                        variant='outlined'
                        onChange={(e) => handleChangeAddLocation('latitude', e.target.value)}
                        sx={{  width:'300px', marginTop:'10px' }}
                        />
                      <TextField
                      InputProps={{
                        style: {
                        color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                        borderColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                      }
                    }}
                    InputLabelProps={{
                      style: {
                        color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                        
                      }
                    }}
                        id="longitude"
                        label="Longitude"
                        type="text"
                        variant='outlined'
                        onChange={(e) => handleChangeAddLocation('longitude', e.target.value)}
                        sx={{  width:'300px', marginTop:'10px',marginLeft:'10px' }}
                        />
                </div>
                <Box sx={{ display: 'flex', flexDirection: 'row', marginTop: '10px', gap: '10px', flexWrap: 'wrap' }}>
                  <FormControl sx={{ width: '190px' }}>
                    <InputLabel id="add-location-region-label">Region</InputLabel>
                    <Select
                      labelId="add-location-region-label"
                      label="Region"
                      value={addLocationData.region || ''}
                      onChange={(e) => handleChangeAddLocation('region', e.target.value)}
                    >
                      {REGION_OPTIONS.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl sx={{ width: '220px' }}>
                    <InputLabel id="add-location-site-status-label">Site Status</InputLabel>
                    <Select
                      labelId="add-location-site-status-label"
                      label="Site Status"
                      value={addLocationData.siteStatus || ''}
                      onChange={(e) => handleChangeAddLocation('siteStatus', e.target.value)}
                    >
                      {SITE_STATUS_OPTIONS.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl sx={{ width: '170px' }}>
                    <InputLabel id="add-location-customer-label">SiCam Customer</InputLabel>
                    <Select
                      labelId="add-location-customer-label"
                      label="SiCam Customer"
                      value={addLocationData.siCamCustomer || ''}
                      onChange={(e) => handleChangeAddLocation('siCamCustomer', e.target.value)}
                    >
                      {SICAM_CUSTOMER_OPTIONS.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </DialogContent>
              <DialogActions sx={{ marginRight:'20px' }}>
                      
                      <Button variant="contained" color="error" onClick={handleAddLocationClose}>Cancel</Button>
                      <Button variant="contained" color="success" onClick={handleSubmitAddLocation}>Save</Button>
              </DialogActions>
            </Dialog>






            {/* DIALOG5 */}
            {/* EDIT LOCATION */}
            {/* DIALOG5 */}
            <Dialog className={`${styles[theme]}`}
                                      PaperProps={{
                                        className: theme === 'light' ? styles['light-dialogPaper'] : styles['dark-dialogPaper'],
                                      }} open={editLocationOpen} onClose={() => setEditLocationOpen(false)} maxWidth="md" fullWidth>
              <DialogTitle>EDIT LOCATION 
              <MdEditLocationAlt style={{ fontSize: '50px', float: 'right' }} />
                      
              </DialogTitle>
                <br></br>
                <DialogContent>
              
               
              <FormControl fullWidth>
              <InputLabel
                className={theme === 'light' ? styles.lightLabel : styles.darkLabel}
                id="demo-simple-select-label"
              >
                Select Location
              </InputLabel>

              {/* Wrap Select & Button in a flex container */}
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                
                {/* Select Dropdown */}
                <Select
                  className={theme === 'light' ? styles.lightSelect : styles.darkSelect}
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  sx={{
                    width: '300px',
                    '& .MuiFormHelperText-root': {
                      color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                    },
                  }}
                  color="success"
                  focused
                  label="Select Location"
                  onChange={handleSelectLocation}
                >
                  {locationData.map((type) => (
                    <MenuItem key={type.LocationID} value={type.LocationID}>
                      {type.CompanyAndDivision}
                    </MenuItem>
                  ))}
                </Select>

                {/* Delete Button shifted to the right */}
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}> 
                  <Button
                    variant="contained"
                    color="error"
                    onClick={handleDeleteLocation}
                    sx={{ marginLeft: 'auto' }} // ✅ Moves the button to the right
                  >
                    Delete Selected Location
                  </Button>

                  {/* WARNING MESSAGE BELOW DELETE BUTTON */}
                  <FormHelperText
                    sx={{
                      color: 'red',
                      fontWeight: 'bold',
                      textAlign: 'center',
                      marginTop: '5px',
                    }}
                  >
                    WARNING: This will delete all actions associated with this location.
                  </FormHelperText>
                </div>
              </div>

              {/* Helper Text */}
              <FormHelperText
                sx={{
                  '& .MuiFormHelperText-root': {
                    color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                  },
                }}
              >
                Select Location to Edit.
              </FormHelperText>
            </FormControl>


                
                <Divider sx={{marginTop:'20px'}} />
                <Box sx={{display: 'flex',flexDirection: 'row'}}>
                <TextField
                InputProps={{
                  style: {
                  color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                  borderColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                }
              }}
              InputLabelProps={{
                style: {
                  color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                  
                }
              }}
                            label="Company Name"
                            variant="outlined"
                            sx={{  width:'300px', marginTop:'20px'}}
                            value={editLocationData.companyName || ''} 
                            onChange={(e) => handleChangeEditLocation('companyName', e.target.value)}
                           
                        />
                <TextField
                InputProps={{
                  style: {
                  color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                  borderColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                }
              }}
              InputLabelProps={{
                style: {
                  color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                  
                }
              }}
                          autoFocus
                          margin="dense"
                          id="division-name"
                          label="Division Name"
                          type="text"
                          variant="outlined"
                          value={editLocationData.divisionName || ''} 
                          onChange={(e) => handleChangeEditLocation('divisionName', e.target.value)}
                          sx={{  width:'300px', marginTop:'20px', marginLeft:'10px' }}
                        />
                </Box>
                <div sx={{display:'flex'}}>
                      <TextField
                      InputProps={{
                        style: {
                        color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                        borderColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                      }
                    }}
                    InputLabelProps={{
                      style: {
                        color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                        
                      }
                    }}
                        id="address"
                        label="Address"
                        type="text"
                        variant='outlined'
                        value={editLocationData.address || ''} 
                        onChange={(e) => handleChangeEditLocation('address', e.target.value)}
                        sx={{  width:'300px', marginTop:'10px' }}
                        />
                        <TextField
                        InputProps={{
                          style: {
                          color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                          borderColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                        }
                      }}
                      InputLabelProps={{
                        style: {
                          color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                          
                        }
                      }}
                        id="postal"
                        label="Postal Code"
                        type="text"
                        variant='outlined'
                        value={editLocationData.postal || ''} 
                        onChange={(e) => handleChangeEditLocation('postal', e.target.value)}
                        sx={{  width:'120px', marginTop:'10px', marginLeft:'10px' }}
                        />
                        <TextField
                        InputProps={{
                          style: {
                          color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                          borderColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                        }
                      }}
                      InputLabelProps={{
                        style: {
                          color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                          
                        }
                      }}
                        id="city"
                        label="City"
                        type="text"
                        variant='outlined'
                        value={editLocationData.city || ''} 
                        onChange={(e) => handleChangeEditLocation('city', e.target.value)}
                        sx={{  width:'170px', marginTop:'10px', marginLeft:'10px' }}
                        />
                        <TextField
                        InputProps={{
                          style: {
                          color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                          borderColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                        }
                      }}
                      InputLabelProps={{
                        style: {
                          color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                          
                        }
                      }}
                        id="state"
                        label="State"
                        type="text"
                        variant='outlined'
                        value={editLocationData.state || ''} 
                        onChange={(e) => handleChangeEditLocation('state', e.target.value)}
                        sx={{  width:'300px', marginTop:'10px' }}
                        />
                        <TextField
                        InputProps={{
                          style: {
                          color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                          borderColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                        }
                      }}
                      InputLabelProps={{
                        style: {
                          color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                          
                        }
                      }}
                        id="country"
                        label="Country"
                        type="text"
                        variant='outlined'
                        value={editLocationData.country || ''} 
                        onChange={(e) => handleChangeEditLocation('country', e.target.value)}
                        sx={{  width:'300px', marginTop:'10px', marginLeft:'10px' }}
                        />
                </div>
                <div sx={{display:'flex'}}>
                      <TextField
                      InputProps={{
                        style: {
                        color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                        borderColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                      }
                    }}
                    InputLabelProps={{
                      style: {
                        color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                        
                      }
                    }}
                        id="longitude"
                        label="Longitude"
                        type="text"
                        variant='outlined'
                        value={editLocationData.longitude || ''} 
                        onChange={(e) => handleChangeEditLocation('longitude', e.target.value)}
                        sx={{  width:'300px', marginTop:'10px' }}
                        />
                        <TextField
                        InputProps={{
                          style: {
                          color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                          borderColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                        }
                      }}
                      InputLabelProps={{
                        style: {
                          color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                          
                        }
                      }}
                        id="latitude"
                        label="Latitude"
                        type="text"
                        variant='outlined'
                        value={editLocationData.latitude || ''} 
                        onChange={(e) => handleChangeEditLocation('latitude', e.target.value)}
                        sx={{  width:'300px', marginTop:'10px', marginLeft:'10px' }}
                        />
                </div>
                <Box sx={{ display: 'flex', flexDirection: 'row', marginTop: '10px', gap: '10px', flexWrap: 'wrap' }}>
                  <FormControl sx={{ width: '190px' }}>
                    <InputLabel id="edit-location-region-label">Region</InputLabel>
                    <Select
                      labelId="edit-location-region-label"
                      label="Region"
                      value={editLocationData.region || ''}
                      onChange={(e) => handleChangeEditLocation('region', e.target.value)}
                    >
                      {REGION_OPTIONS.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl sx={{ width: '220px' }}>
                    <InputLabel id="edit-location-site-status-label">Site Status</InputLabel>
                    <Select
                      labelId="edit-location-site-status-label"
                      label="Site Status"
                      value={editLocationData.siteStatus || ''}
                      onChange={(e) => handleChangeEditLocation('siteStatus', e.target.value)}
                    >
                      {SITE_STATUS_OPTIONS.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl sx={{ width: '170px' }}>
                    <InputLabel id="edit-location-customer-label">SiCam Customer</InputLabel>
                    <Select
                      labelId="edit-location-customer-label"
                      label="SiCam Customer"
                      value={editLocationData.siCamCustomer || ''}
                      onChange={(e) => handleChangeEditLocation('siCamCustomer', e.target.value)}
                    >
                      {SICAM_CUSTOMER_OPTIONS.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </DialogContent>
              <DialogActions sx={{ marginRight:'20px' }}>
                      
                      <Button variant="contained" color="error" onClick={handleEditLocationClose}>Cancel</Button>
                      <Button variant="contained" color="success" onClick={handleSubmitEditLocation}>Save</Button>
              </DialogActions>

            </Dialog>






            {/* DIALOG6 */}
            {/* ASSIGN SUPPORT PLAN */}
            {/* DIALOG6 */}

            <Dialog className={`${styles[theme]}`}
                                      PaperProps={{
                                        className: theme === 'light' ? styles['light-dialogPaper'] : styles['dark-dialogPaper'],
                                      }}open={editPlanOpen} onClose={() => setEditPlanOpen(false)} maxWidth="lg" fullWidth>
              <DialogTitle >SUPPORT PLAN
              <MdStars style={{ fontSize: '40px', float: 'right' }} />
                      
              </DialogTitle>
                <br></br>
              <DialogContent>
              <div>
              <Box sx={{display:'flex'}}>
              <FormControl fullWidth >
                            <InputLabel className={theme === 'light' ? styles.lightLabel : styles.darkLabel} id="demo-simple-select-label">Select Location</InputLabel>
                            <Select
                            className={theme === 'light' ? styles.lightSelect : styles.darkSelect}
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                sx={{  width:'300px'}}
                                color="success" focused
                                label="Select Location"
                                onChange={handleSelectLocationPlan}
                            >
                                {locationData.map((type) => (
                              <MenuItem key={type.LocationID} value={type.LocationID}>
                                {type.CompanyAndDivision}
                              </MenuItem>
                            ))}
                            </Select>
                           
                </FormControl>
                <ColorButton  variant="contained" color="success" style={{fontSize:'12px', width:'320px', height:'50px'}} onClick={handleEditBasicPlanOpen}> <BsListStars     style={{fontSize:'30px', margin:'0px', paddingRight:'10px'}}  />Edit Standard Plan </ColorButton >
                <ColorButton  variant="contained" color="success" style={{fontSize:'12px', width:'300px', height:'50px', marginLeft:'10px'}} onClick={handleEditPremiumPlanOpen}> <BsListStars     style={{fontSize:'30px', margin:'0px', paddingRight:'10px'}}  />Edit Premium Plan </ColorButton >
                </Box>
                <Divider sx={{'&.MuiDivider-root': {
                            backgroundColor: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                          }, marginTop:'20px'}} />
                <Box sx={{display:'flex'}}>
                <Card sx={{ '&.MuiPaper-root': {
                            backgroundColor: theme === 'light' ? '#FFFFF' : '#3a423c57',
                            color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                          }, width: 450, marginTop:'20px',borderRadius:'20px' }}>
                  <CardContent >
                  
                    <div>
                      <Typography sx={{'&.MuiTypography-root': {
                            color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                          }, fontSize: 14 }} color="text.secondary" gutterBottom>
                      <u><b>Current</b> Maintenance Plan</u>
                      </Typography>
                     
                      
                    </div>
                    <div>
                      <Typography variant="body2">
                      <Rating sx={{marginLeft:'0px', marginBottom:'20px', fontSize:'40px'}} 
                        name="size-large"
                        value={editPlanData ? (editPlanData.supportStatusBefore) : 0}            
                        max={3} 
                        readOnly={true} 
                        />
                      </Typography>
                      <Typography variant="h5" component="div" sx={{
                          fontFamily: 'DM Serif Display, serif',
                          fontWeight: '400',
                          fontStyle: 'italic'
                        }}>
                        {editPlanData ? getSupportStatusText(editPlanData.supportStatusBefore) : ''}
                      </Typography>
                      <Divider sx={{marginTop:'10px'}} />
                      
                      <Typography variant="button" display="block" gutterBottom sx={{marginTop:'10px'}}>
                        Start Date: {editPlanData.supportStartDateBefore ? editPlanData.supportStartDateBefore.split('T')[0] : 'N/A'}  
                      </Typography>
                      <Typography variant="button" display="block" gutterBottom sx={{marginTop:'0px'}}>
                        End Date: {editPlanData.supportEndDateBefore ? editPlanData.supportEndDateBefore.split('T')[0] : 'N/A'}
                      </Typography>
                      
                    </div>
                   
                  </CardContent>
                 
                </Card>
                <IoIosArrowForward style={{ fontSize: '50px',  marginTop:'60px', marginLeft:'20px' }}  />
                <Card sx={{ '&.MuiPaper-root': {
                            backgroundColor: theme === 'light' ? '#FFFF' : '#3a423c57',
                            color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                          },width: 600, marginTop:'20px', marginLeft:'20px',borderRadius:'20px' }}>
                  <CardContent>
                  
                    <div>
                      <Typography sx={{'&.MuiTypography-root': {
                            color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                          }, fontSize: 14 }} color="text.secondary" gutterBottom>
                      <u><b>New</b> Maintenance Plan</u>
                      </Typography>
                     
                      
                    </div>
                    <div>
                      <Typography variant="body2">
                      <Rating sx={{marginLeft:'0px', marginBottom:'20px', fontSize:'40px'}} 
                        name="size-large"
                        defaultValue={0} 
                        onChange={(event, newValue) => {
                              setEditPlanData({ ...editPlanData, supportStatusAfter: newValue, supportEndDateAfter: null, supportStartDateAfter: null });
                            }}              
                        max={3} 
                        />
                      </Typography>
                      <Typography variant="h5" component="div" sx={{
                          fontFamily: 'DM Serif Display, serif',
                          fontWeight: '400',
                          fontStyle: 'italic'
                        }}>
                        {editPlanData ? getSupportStatusText(editPlanData.supportStatusAfter) : ''}
                      </Typography>
                      <Divider sx={{marginTop:'10px'}} />
                      
                       <Box sx={{display:'flex'}}> 
                        <LocalizationProvider dateAdapter={AdapterDayjs} >
                          <DemoContainer components={['DatePicker']} sx={{  marginTop:'10px', width:'200px'}}>
                            <DatePicker label="Set Start Date" 
                            onChange={handleStartDateChange}
                            inputFormat="YYYY-MM-DD"  // Set the display format here
                            renderInput={(params) => <TextField {...params}  />}
                            sx={{
                              '& .MuiInputLabel-root': {
                                color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                              },
                              '& .MuiInputBase-input': {
                                color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                              },
                              '& .MuiInput-underline:before, & .MuiInput-underline:after': {
                                borderBottomColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                              },
                              '& .MuiIconButton-root': {
                                color: theme === 'light' ? '#000000' : 'rgba(176, 185, 193, 0.98)',
                              },
                              
                            }}
                            />
                            
                          </DemoContainer>
                        </LocalizationProvider>
                      
                      <Typography variant="button" display="block" gutterBottom sx={{marginTop:'30px', marginLeft:'50px'}}>
                        End Date: {editPlanData.supportEndDateAfter ? editPlanData.supportEndDateAfter.split('T')[0] : 'N/A'}
                      </Typography>
                      </Box> 

                      <FormControl  margin="dense" sx={{  width:'300px', marginBottom:'30px' }}>
                          <InputLabel className={theme === 'light' ? styles.lightLabel : styles.darkLabel}  id="employee-label2">Assign SiCam Employee</InputLabel>
                          <Select
                          className={theme === 'light' ? styles.lightSelect : styles.darkSelect}
                            labelId="employee-label2"
                            id="employee-select2"
                            label="Assign SiCam Employee"
                            onChange={(e) => handleChangeAssignEmp('employee', e.target.value)}
                            
                          >
                            {employeeData.map((type) => (
                              <MenuItem key={type.EmployeeID} value={type.EmployeeID}>
                                {type.EmployeeName}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      
                    </div>
                   
                  </CardContent>
                 
                </Card>
                </Box>
                
                
                
                </div>
                {editPlanFeedback.message ? (
                  <Alert severity={editPlanFeedback.severity || 'info'} sx={{ mt: 2 }}>
                    {editPlanFeedback.message}
                  </Alert>
                ) : null}
              </DialogContent>
              <DialogActions sx={{ marginRight:'20px' }}>
                      
                      <Button variant="contained" color="error" onClick={handleEditPlanClose}>Cancel</Button>
                      <Button variant="contained" color="success" onClick={handleSubmitEditPlan}>Save</Button>
              </DialogActions>

            </Dialog>



            {/* DIALOG7 */}
            {/* ADD NEW CONTACT */}
            {/* DIALOG7 */}

            <Dialog className={`${styles[theme]}`}
                                      PaperProps={{
                                        className: theme === 'light' ? styles['light-dialogPaper'] : styles['dark-dialogPaper'],
                                      }}open={addContactOpen} onClose={() => setAddContactOpen(false)} maxWidth="md" >
            
              <DialogTitle>CONTACT 
              <br></br>
              <BiSolidContact style={{ fontSize: '50px', float: 'right', margin:'0px' }} />
                      
              </DialogTitle>
                <br></br>
              <DialogContent>
              <Divider sx={{marginBottom:'10px',marginTop:'10px'}} />
              
              <br></br>
              
              <Button variant="contained" style={{fontSize:'12px'}} onClick={handleEditContactOpen}> <BiSolidContact    style={{fontSize:'30px', margin:'0px', paddingRight:'3px'}}  />Edit Existing Contact </Button>
              <Divider sx={{marginBottom:'10px',marginTop:'40px'}} />
              <Typography variant="h7" gutterBottom sx={{marginTop:'10px'}}>
                NEW CONTACT
              </Typography>
              
              <div sx={{display: 'flex',flexDirection: 'row'}}>

                                       
                <TextField
                InputProps={{
                  style: {
                  color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                  borderColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                }
              }}
              InputLabelProps={{
                style: {
                  color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                  
                }
              }}
                  autoFocus
                  margin="dense"
                  id="first-name"
                  label="First Name"
                  type="text"
                  variant="outlined"
                 
                    onChange={(e) => handleChangeAddContact('firstName', e.target.value)}
                    sx={{  width:'300px', marginTop:'38px', marginLeft:'0px' }}
                  />
                  <TextField
                 InputProps={{
                  style: {
                  color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                  borderColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                }
              }}
              InputLabelProps={{
                style: {
                  color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                  
                }
              }}
                    autoFocus
                    margin="dense"
                    id="last-name"
                    label="Last Name"
                    type="text"
                    variant="outlined"
                  
                    onChange={(e) => handleChangeAddContact('lastName', e.target.value)}
                    sx={{  width:'300px', marginTop:'38px', marginLeft:'10px' }}
                  />
                  
                </div>
                <Box sx={{display:'flex'}}>
                      <TextField
                      InputProps={{
                        style: {
                        color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                        borderColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                      }
                    }}
                    InputLabelProps={{
                      style: {
                        color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                        
                      }
                    }}
                        id="title"
                        label="Title"
                        type="text"
                        variant='outlined'
                       
                        onChange={(e) => handleChangeAddContact('title', e.target.value)}
                        sx={{  width:'300px', marginTop:'10px' }}
                        />
                       
                      <FormControl  >
                       <InputLabel className={theme === 'light' ? styles.lightLabel : styles.darkLabel} id="demo-simple-select-label2">Assign Location</InputLabel>
                       <Select
                        className={theme === 'light' ? styles.lightSelect : styles.darkSelect}
                           labelId="demo-simple-select-label2"
                           id="demo-simple-select2"
                           sx={{  width:'300px', marginTop:'10px', marginLeft:'10px'}}
                           label="Assign Location"
                           onChange={(e) => handleChangeAddContact('locationID', e.target.value)}
                       >
                           {locationData.map((type) => (
                         <MenuItem key={type.locationid} value={type.locationid}>
                           {type.CompanyAndDivision}
                         </MenuItem>
                       ))}
                       </Select>
                   </FormControl>
                   </Box>
                  
                        <TextField
                        InputProps={{
                          style: {
                          color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                          borderColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                        }
                      }}
                      InputLabelProps={{
                        style: {
                          color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                          
                        }
                      }}
                        id="email"
                        label="Email"
                        type="text"
                        variant='outlined'
                       
                        onChange={(e) => handleChangeAddContact('email', e.target.value)}
                        sx={{  width:'610px', marginTop:'10px', marginLeft:'0px' }}
                        />
                        <Box sx={{display:'flex'}}>
                        <TextField
                       InputProps={{
                        style: {
                        color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                        borderColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                      }
                    }}
                    InputLabelProps={{
                      style: {
                        color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                        
                      }
                    }}
                        id="cell"
                        label="Cell Phone"
                        type="text"
                        variant='outlined'
                       
                        onChange={(e) => handleChangeAddContact('cell', e.target.value)}
                        sx={{  width:'240px', marginTop:'10px' }}
                        />
                        <TextField
                        InputProps={{
                          style: {
                          color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                          borderColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                        }
                      }}
                      InputLabelProps={{
                        style: {
                          color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                          
                        }
                      }}
                        id="office"
                        label="Office Phone"
                        type="text"
                        variant='outlined'
                       
                        onChange={(e) => handleChangeAddContact('office', e.target.value)}
                        sx={{  width:'240px', marginTop:'10px', marginLeft:'10px' }}
                        />
                        <TextField
                       InputProps={{
                        style: {
                        color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                        borderColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                      }
                    }}
                    InputLabelProps={{
                      style: {
                        color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                        
                      }
                    }}
                        id="ext"
                        label="Extension"
                        type="text"
                        variant='outlined'
                       
                        onChange={(e) => handleChangeAddContact('ext', e.target.value)}
                        sx={{  width:'110px', marginTop:'10px', marginLeft:'10px' }}
                        />
                        </Box>
                
                
              </DialogContent>
              <DialogActions sx={{ marginRight:'20px' }}>
                      
                      <Button variant="contained" color="error" onClick={handleAddContactClose}>Cancel</Button>
                      <Button variant="contained" color="success" onClick={handleSubmitAddContact}>
                          Save
                      </Button>
              </DialogActions>
            </Dialog>



            {/* DIALOG8 */}
            {/* EDIT CONTACT */}
            {/* DIALOG8 */}

            <Dialog className={`${styles[theme]}`}
                                      PaperProps={{
                                        className: theme === 'light' ? styles['light-dialogPaper'] : styles['dark-dialogPaper'],
                                      }}open={editContactOpen} onClose={() => setEditContactOpen(false)} maxWidth="md" >
            
              <DialogTitle>EDIT CONTACT 
              <BsPersonPlusFill style={{ fontSize: '50px', float: 'right', margin:'0px' }} />
                      
              </DialogTitle>
                <br></br>
              <DialogContent>
              <div sx={{display: 'flex',flexDirection: 'row'}}>
              <FormControl component="fieldset">
                 <FormControl fullWidth>
                  <InputLabel className={theme === 'light' ? styles.lightLabel : styles.darkLabel} id="demo-simple-select-label">Select Contact</InputLabel>
                  <Select
                   className={theme === 'light' ? styles.lightSelect : styles.darkSelect}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      sx={{  width:'300px'}}
                      label="Select Company"
                      onChange={handleSelectContact}
                      
                  >
                      {contactData.map((type) => (
                    <MenuItem key={type.ContactID} value={type.ContactID}>
                      {type.FirstName} {type.LastName}
                    </MenuItem>
                  ))}
                  </Select>
              </FormControl>
 
                </FormControl>
                <div sx={{display:'flex'}}>
                
                <TextField
                     InputProps={{
                      style: {
                      color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                      borderColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                    }
                  }}
                  InputLabelProps={{
                    style: {
                      color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                      
                    }
                  }}
                  autoFocus
                  margin="dense"
                  id="first-name"
                  label="First Name"
                  type="text"
                  variant="outlined"
                  value={editContactData.firstName}
                    onChange={(e) => handleChangeEditContact('firstName', e.target.value)}
                    sx={{  width:'300px', marginTop:'38px', marginLeft:'0px' }}
                  />
                  <TextField
                       InputProps={{
                        style: {
                        color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                        borderColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                      }
                    }}
                    InputLabelProps={{
                      style: {
                        color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                        
                      }
                    }}
                    autoFocus
                    margin="dense"
                    id="last-name"
                    label="Last Name"
                    type="text"
                    variant="outlined"
                    value={editContactData.lastName}
                    onChange={(e) => handleChangeEditContact('lastName', e.target.value)}
                    sx={{  width:'300px', marginTop:'38px', marginLeft:'10px' }}
                  />
                  </div>
                </div>
                <Box sx={{display:'flex'}}>
                      <TextField
                           InputProps={{
                            style: {
                            color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                            borderColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                          }
                        }}
                        InputLabelProps={{
                          style: {
                            color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                            
                          }
                        }}
                        id="title"
                        label="Title"
                        type="text"
                        variant='outlined'
                        value={editContactData.title}
                        onChange={(e) => handleChangeEditContact('title', e.target.value)}
                        sx={{  width:'300px', marginTop:'10px' }}
                        />
                       
                      <FormControl  >
                       <InputLabel className={theme === 'light' ? styles.lightLabel : styles.darkLabel} id="demo-simple-select-label2">Assign Location</InputLabel>
                       <Select
                       className={theme === 'light' ? styles.lightSelect : styles.darkSelect}
                           labelId="demo-simple-select-label2"
                           id="demo-simple-select2"
                           sx={{  width:'300px', marginTop:'10px', marginLeft:'10px'}}
                           label="Assign Location"
                           value={editContactData.locationID}
                           onChange={(e) => handleChangeEditContact('locationID', e.target.value)}
                       >
                           {locationData.map((type) => (
                         <MenuItem key={type.locationid} value={type.locationid}>
                           {type.CompanyAndDivision}
                         </MenuItem>
                       ))}
                       </Select>
                   </FormControl>
                   </Box>
                  
                        <TextField
                             InputProps={{
                              style: {
                              color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                              borderColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                            }
                          }}
                          InputLabelProps={{
                            style: {
                              color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                              
                            }
                          }}
                        id="email"
                        label="Email"
                        type="text"
                        variant='outlined'
                        value={editContactData.email}
                        onChange={(e) => handleChangeEditContact('email', e.target.value)}
                        sx={{  width:'610px', marginTop:'10px', marginLeft:'0px' }}
                        />
                        <Box sx={{display:'flex'}}>
                        <TextField
                             InputProps={{
                              style: {
                              color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                              borderColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                            }
                          }}
                          InputLabelProps={{
                            style: {
                              color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                              
                            }
                          }}
                        id="cell"
                        label="Cell Phone"
                        type="text"
                        variant='outlined'
                        value={editContactData.cell || ''}
                        onChange={(e) => handleChangeEditContact('cell', e.target.value)}
                        sx={{  width:'240px', marginTop:'10px' }}
                        />
                        <TextField
                             InputProps={{
                              style: {
                              color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                              borderColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                            }
                          }}
                          InputLabelProps={{
                            style: {
                              color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                              
                            }
                          }}
                        id="office"
                        label="Office Phone"
                        type="text"
                        variant='outlined'
                        value={editContactData.office || ''}
                        onChange={(e) => handleChangeEditContact('office', e.target.value)}
                        sx={{  width:'240px', marginTop:'10px', marginLeft:'10px' }}
                        />
                        <TextField
                             InputProps={{
                              style: {
                              color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                              borderColor: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                            }
                          }}
                          InputLabelProps={{
                            style: {
                              color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                              
                            }
                          }}
                        id="ext"
                        label="Extension"
                        type="text"
                        variant='outlined'
                        value={editContactData.ext|| ''}
                        onChange={(e) => handleChangeEditContact('ext', e.target.value)}
                        sx={{  width:'110px', marginTop:'10px', marginLeft:'10px' }}
                        />
                        </Box>
                
                
              </DialogContent>
              <DialogActions sx={{ marginRight:'20px' }}>
                      
                      <Button variant="contained" color="error" onClick={handleEditContactClose}>Cancel</Button>
                      <Button variant="contained" color="success" onClick={handleSubmitEditContact}>
                          Save
                      </Button>
              </DialogActions>
            </Dialog>


            {/* DIALOG9 */}
            {/* EDIT STANDARD PLAN */}
            {/* DIALOG 9*/}

            <Dialog className={`${styles[theme]}`}
                                      PaperProps={{
                                        className: theme === 'light' ? styles['light-dialogPaper'] : styles['dark-dialogPaper'],
                                      }}fullScreen open={editBasicPlanOpen} onClose={() => setEditBasicPlanOpen(false)} maxWidth="md" TransitionComponent={Transition} >
            
        
        
              <DialogTitle>EDIT STANDARD PLAN
              <BsListStars style={{ fontSize: '50px', float: 'right', margin:'0px' }} />
                      
              </DialogTitle>
                <br></br>
              <DialogContent>
              <Box sx={{display: 'flex'}}>
              <Box sx={{display: 'flex',flexDirection: 'row',width: '70%',height: '100%',}}>
               {/* BOX1 */}
              <Box sx={{m:1,width:'100%'}}>
                <Paper elevation={1}> 
                
                <Box className={`${styles.box} ${styles[theme]}`}
                    sx={{
                      display: 'flex', // Use flex display
                      justifyContent: 'center', // Center the content horizontally
                      alignItems: 'center', // Align items vertically in the center
                      paddingTop: '8px', // Optional padding at the top
                      paddingBottom: '8px', // Optional padding at the bottom
                    }}
                  >
                    {/* Typography for "Actions" text */}
                    <Typography 
                      sx={{
                        fontFamily: 'DM Serif Display, serif',
                        fontWeight: '400',
                        fontStyle: 'normal',
                        textAlign: 'center',
                        flexGrow: 1, // Allows the text to grow and push the icon to the right
                      }}
                      variant="h6"
                      gutterBottom
                    >
                      STANDARD PLAN :  ACTIONS
                    </Typography>
                    
                     {/* IconButton wrapping the IoMdAddCircle icon */}
                    <Button onClick={handleNewActionDialogOpen} aria-label="add">
                      <MdOutlineLibraryAdd style={{ fontSize: '30px', float: 'right' }} />
                    </Button>
                    
                   </Box>
               
                </Paper> 
                
                
                

                  {/* TABLE DATA* */}
                  {/* TABLE DATA*/}
                  {/* TABLE DATA**/}


                  <style>
                    {`
                      .my-datagrid .MuiDataGrid-columnHeaders, .my-datagrid .MuiDataGrid-columnHeaderTitle {
                        background-color: #f0f0f0; /* Change to your desired color */
                        font-weight: bold; /* Makes the font bold */
                      }
                      .my-datagrid .MuiDataGrid-columnHeaderTitleContainer {
                        background-color: inherit; /* Ensure the background color fills the whole header */
                      }
                    `}
                    </style>

                <TableContainer  component={Paper} style={{ height: '76vh', overflowY: 'auto' }}  >
                {/* <div style={{ height: '85vh', width: '100%' }}> */}
                  <DataGrid
                  className="my-datagrid"
                    rows={standardPlanData}
                    columns={columns2}
                    getRowId={getRowId}
                    initialState={{
                      pagination: {
                        paginationModel: { page: 0, pageSize: 15 },
                      },
                    }}
                    pageSizeOptions={[5, 10]}
                    //checkboxSelection
                  />
                </TableContainer>
              </Box>
            </Box> 
            <div>
            <Card sx={{ minWidth: 500, marginTop: '10px', marginLeft:'30px'}}>
              <CardContent>
                <Typography sx={{ fontSize: 18 }} color="text.secondary" gutterBottom>
                <BsFillInfoCircleFill  style={{ fontSize: '35px' }}/> 
                </Typography>
                <Typography variant="h5" component="div">
                 Standard Plan
                </Typography>
                
                <Typography variant="body2">
                  Develop pre-made actions for the standard plan. These actions will be assigned to the location when they choose the standard plan.
                  <br />
                </Typography>
                <br />
                
                <Typography sx={{ mb: 1.5 }} color="text.secondary">
                  Due Date Days Column: 
                </Typography>
                <Typography variant="body2">
                This number will be added to the start date and due date for that action will be assigned.
                  <br />
                </Typography>
              </CardContent>
             
            </Card>
            </div>
            </Box>
            
              </DialogContent>
              <DialogActions sx={{ marginRight:'20px', marginBottom:'40px' }}>
                      
                      <Button variant="contained" size="large"  color="error" onClick={handleEditBasicPlanClose}>Close</Button>
                     
              </DialogActions>
            </Dialog>




            {/* DIALOG10 */}
            {/* EDIT PREMIUM PLAN */}
            {/* DIALOG10 */}

            <Dialog className={`${styles[theme]}`}
                                      PaperProps={{
                                        className: theme === 'light' ? styles['light-dialogPaper'] : styles['dark-dialogPaper'],
                                      }} fullScreen open={editPremiumPlanOpen} onClose={() => setEditPremiumPlanOpen(false)} maxWidth="md" TransitionComponent={Transition} >
            
              <DialogTitle>EDIT PREMIUM PLAN
              <BsListStars style={{ fontSize: '50px', float: 'right', margin:'0px' }} />
                      
              </DialogTitle>
                <br></br>
                <DialogContent>
              <Box sx={{display: 'flex'}}>
              <Box sx={{display: 'flex',flexDirection: 'row',width: '70%',height: '100%',}}>
              {/* BOX1 */}
              <Box sx={{m:1,width:'100%'}}>
                <Paper elevation={1}> 
                
                <Box className={`${styles.box} ${styles[theme]}`}
                    sx={{
                      display: 'flex', // Use flex display
                      justifyContent: 'center', // Center the content horizontally
                      alignItems: 'center', // Align items vertically in the center
                      paddingTop: '8px', // Optional padding at the top
                      paddingBottom: '8px', // Optional padding at the bottom
                    }}
                  >
                    {/* Typography for "Actions" text */}
                    <Typography 
                      sx={{
                        fontFamily: 'DM Serif Display, serif',
                        fontWeight: '400',
                        fontStyle: 'normal',
                        textAlign: 'center',
                        flexGrow: 1, // Allows the text to grow and push the icon to the right
                      }}
                      variant="h6"
                      gutterBottom
                    >
                      PREMIUM PLAN :  ACTIONS
                    </Typography>
                    
                    {/* IconButton wrapping the IoMdAddCircle icon */}
                    <Button onClick={handleNewActionDialogOpen2} aria-label="add">
                      <MdOutlineLibraryAdd style={{ fontSize: '30px', float: 'right' }} />
                    </Button>
                    
                  </Box>
              
                </Paper> 
                
                
                

                  {/* TABLE DATA* */}
                  {/* TABLE DATA*/}
                  {/* TABLE DATA**/}


                  <style>
                    {`
                      .my-datagrid .MuiDataGrid-columnHeaders, .my-datagrid .MuiDataGrid-columnHeaderTitle {
                        background-color: #f0f0f0; /* Change to your desired color */
                        font-weight: bold; /* Makes the font bold */
                      }
                      .my-datagrid .MuiDataGrid-columnHeaderTitleContainer {
                        background-color: inherit; /* Ensure the background color fills the whole header */
                      }
                    `}
                    </style>

                <TableContainer  component={Paper} style={{ height: '76vh', overflowY: 'auto' }}  >
                {/* <div style={{ height: '85vh', width: '100%' }}> */}
                  <DataGrid
                  className="my-datagrid"
                    rows={premiumPlanData}
                    columns={columns3}
                    getRowId={getRowId2}
                    initialState={{
                      pagination: {
                        paginationModel: { page: 0, pageSize: 15 },
                      },
                    }}
                    pageSizeOptions={[5, 10]}
                    //checkboxSelection
                  />
                </TableContainer>
              </Box>
              </Box> 
              <div>
            <Card sx={{ minWidth: 500, marginTop: '10px', marginLeft:'30px'}}>
              <CardContent>
                <Typography sx={{ fontSize: 18 }} color="text.secondary" gutterBottom>
                <BsFillInfoCircleFill  style={{ fontSize: '35px' }}/> 
                </Typography>
                <Typography variant="h5" component="div">
                 Premium Plan
                </Typography>
                
                <Typography variant="body2">
                  Develop pre-made actions for the premium plan. These actions will be assigned to the location when they choose the premium plan.
                  <br />
                </Typography>
                <br />
                
                <Typography sx={{ mb: 1.5 }} color="text.secondary">
                  Due Date Days Column: 
                </Typography>
                <Typography variant="body2">
                This number will be added to the start date and due date for that action will be assigned.
                  <br />
                </Typography>
              </CardContent>
             
            </Card>
            </div>
            </Box>

              </DialogContent>
              <DialogActions sx={{ marginRight:'20px', marginBottom:'40px' }}>
                      
                      <Button variant="contained" size="large"  color="error" onClick={handleEditPremiumPlanClose}>Close</Button>
                      
              </DialogActions>
            </Dialog>


            
                  {/* DIALOG11 */}
                  {/* NEW ACTION */}
                  {/* DIALOG11*/}


                  <Dialog open={openNewAction} onClose={handleNewActionDialogClose} maxWidth="md" sx={{  width: '100%' }}>
                      <DialogTitle>NEW STANDARD ACTION
                      <MdOutlineLibraryAdd style={{ fontSize: '30px', float: 'right' }} />
                      </DialogTitle>
                      <br></br>
                      <DialogContent>
                     
                      <br></br>
                      <div sx={{display: 'flex',flexDirection: 'row'}}>
                           {/* Action Name */}
                        <TextField
                          autoFocus
                          margin="dense"
                          id="action-name"
                          label="Action Name"
                          type="text"
                          variant="outlined"
                          value={addActionDataSPlan.actionName}
                          onChange={(e) => handleChangeNewActionSPlan('actionName', e.target.value)}
                          sx={{  width:'620px' }}
                        />
                        </div>
                        <Box sx={{display: 'flex',flexDirection: 'row'}}>

                        {/* Action Type Dropdown */}
                        <Box sx={{ display: 'flex', flexDirection: 'column', marginTop:'10px' }}>
                          <FormControl  margin="dense" sx={{ marginLeft:'0px', width:'150px', marginTop:'0px' }}>
                            <InputLabel id="action-type-label">Action Type</InputLabel>
                            <Select
                              labelId="action-type-label"
                              id="action-type-select"
                              value={addActionDataSPlan.actionTypeID}
                              label="Action Type"
                              onChange={(e) => handleChangeNewActionSPlan('actionTypeID', e.target.value)}
                            >
                               {actionTypeData.map((type) => (
                                <MenuItem key={type.ActionTypeID} value={type.ActionTypeID}>
                                  {type.ActionTypeName}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          <Button sx={{ mt: 1 }} size="small" onClick={() => handleOpenActionTypeDialog('standard-new')}>
                            Add Action Type
                          </Button>
                        </Box>

                          <TextField
                            id="dueDateDats"
                            label="DueDate: Enter Days from Start Date"
                            type="number"
                            variant='outlined'
                            value={addActionDataSPlan.dueDays}
                            onChange={(e) => handleChangeNewActionSPlan('dueDays', e.target.value)}
                            sx={{  width:'320px', marginTop:'10px', marginLeft:'10px' }}
                          />
                          <TextField
                            id="sortOrder"
                            label="Sort Order"
                            type="number"
                            variant='outlined'
                            value={addActionDataSPlan.sortOrder}
                            onChange={(e) => handleChangeNewActionSPlan('sortOrder', e.target.value)}
                            sx={{  width:'130px', marginTop:'10px', marginLeft:'10px' }}
                          />


                        

                      </Box>
                        
                      </DialogContent>
                      <DialogActions sx={{ marginRight:'20px' }}>
                      
                        <Button variant="outlined" color="error" onClick={handleNewActionDialogClose}>Cancel</Button>
                        <Button variant="contained" color="success"  onClick={handleSubmitNewActionSPlan}>Save</Button>
                      </DialogActions>
                      
                    </Dialog>



                  {/* DIALOG12 */}
                  {/* EDIT ACTION */}
                  {/* DIALOG12 */}


                  <Dialog open={openEditAction} onClose={handleEditActionDialogClose} maxWidth="md" fullWidth>
                      <DialogTitle>EDIT STANDARD ACTION
                      <MdOutlineLibraryAdd style={{ fontSize: '30px', float: 'right' }} />
                      </DialogTitle>
                      <br></br>
                      <DialogContent>
                     
                      <br></br>
                      <div sx={{display: 'flex',flexDirection: 'row'}}>
                           {/* Action Name */}
                        <TextField
                          autoFocus
                          margin="dense"
                          id="action-name"
                          label="Action Name"
                          type="text"
                          variant="outlined"
                          value={editActionDataPlan.actionName || ''}
                          onChange={(e) => handleChangeEditAction2('actionName', e)}  // 'e' is the event
                          sx={{  width:'620px' }}
                        />
                      </div>
                       
                        <Box sx={{display: 'flex',flexDirection: 'row'}}>          
                        {/* Action Type Dropdown */}
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                          <FormControl  margin="dense" sx={{ marginLeft:'0px', width:'150px' }}>
                            <InputLabel id="action-type-label">Action Type</InputLabel>
                            <Select
                              labelId="action-type-label"
                              id="action-type-select"
                              value={editActionDataPlan.actionTypeID}
                              label="Action Type"
                              onChange={(e) => handleChangeEditAction2('actionTypeID', e.target.value)}
                            >
                               {actionTypeData.map((type) => (
                                <MenuItem key={type.ActionTypeID} value={type.ActionTypeID}>
                                  {type.ActionTypeName}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          <Button sx={{ mt: 1 }} size="small" onClick={() => handleOpenActionTypeDialog('standard-edit')}>
                            Add Action Type
                          </Button>
                        </Box>
                        <TextField
                                id="dueDateDats"
                                label="DueDate: Enter Days from Start Date"
                                type="number"
                                variant='outlined'
                                value={editActionDataPlan.dueDays}
                                onChange={(e) => handleChangeEditAction2('dueDays', e.target.value)}
                                sx={{  width:'320px', marginTop:'10px', marginLeft:'10px' }}
                              />
                              <TextField
                                id="sortOrder"
                                label="Sort Order"
                                type="number"
                                variant='outlined'
                                value={editActionDataPlan.sortOrder}
                                onChange={(e) => handleChangeEditAction2('sortOrder', e.target.value)}
                                sx={{  width:'130px', marginTop:'10px', marginLeft:'10px' }}
                              />

                      </Box>
                       
                      
                       
                      </DialogContent>
                      <DialogActions sx={{ marginRight:'20px' }}>
                      
                        <Button variant="outlined" color="error" onClick={handleEditActionDialogClose}>Cancel</Button>
                        <Button variant="contained" color="success" onClick={handleEditActionSaveSPlan}>Save</Button>
                      </DialogActions>
                      
                    </Dialog>

                  {/* DIALOG13 */}
                  {/* DELETE ACTION CONFIRMATION*/}
                  {/* DIALOG13 */}


                  <Dialog open={openDeleteAction} onClose={handleDeleteActionDialogClose} maxWidth="xs" fullWidth>
                      <DialogTitle>DELETE STANDARD ACTION
                      <MdOutlineLibraryAdd style={{ fontSize: '30px', float: 'right' }} />
                      </DialogTitle>
                      <br></br>
                      <DialogContent>
                     
                      <br></br>
                     

                      <Typography 
                      sx={{
                        fontFamily: 'DM Serif Display, serif',
                        fontWeight: '400',
                        fontStyle: 'normal',
                        textAlign: 'center',
                        flexGrow: 1, // Allows the text to grow and push the icon to the right
                      }}
                      variant="h6"
                      gutterBottom
                    >
                     Are you sure?
                    </Typography>
                       
                      
                       
                      </DialogContent>
                      <DialogActions sx={{ marginRight:'20px' }}>
                      
                        <Button variant="outlined" color="error" onClick={handleDeleteActionDialogClose}>Cancel</Button>
                        <Button variant="contained" color="success" onClick={handleDeleteActionSaveSPlan}>Yes</Button>
                      </DialogActions>
                      
                    </Dialog>

                  {/* DIALOG14 */}
                  {/* NEW ACTION */}
                  {/* DIALOG14*/}


                  <Dialog open={openNewAction2} onClose={handleNewActionDialogClose2} maxWidth="md" sx={{  width: '100%' }}>
                      <DialogTitle>NEW PREMIUM ACTION
                      <MdOutlineLibraryAdd style={{ fontSize: '30px', float: 'right' }} />
                      </DialogTitle>
                      <br></br>
                      <DialogContent>
                     
                      <br></br>
                      <div sx={{display: 'flex',flexDirection: 'row'}}>
                           {/* Action Name */}
                        <TextField
                          autoFocus
                          margin="dense"
                          id="action-name"
                          label="Action Name"
                          type="text"
                          variant="outlined"
                          value={addActionDataPPlan.actionName}
                          onChange={(e) => handleChangeNewActionPPlan('actionName', e.target.value)}
                          sx={{  width:'620px' }}
                        />
                        </div>
                        <Box sx={{display: 'flex',flexDirection: 'row'}}>

                            {/* Action Type Dropdown */}
                            <Box sx={{ display: 'flex', flexDirection: 'column', marginTop:'10px' }}>
                              <FormControl  margin="dense" sx={{ marginLeft:'0px', width:'150px', marginTop:'0px' }}>
                                <InputLabel id="action-type-label">Action Type</InputLabel>
                                <Select
                                  labelId="action-type-label"
                                  id="action-type-select"
                                  value={addActionDataPPlan.actionTypeID}
                                  label="Action Type"
                                  onChange={(e) => handleChangeNewActionPPlan('actionTypeID', e.target.value)}
                                >
                                  {actionTypeData.map((type) => (
                                    <MenuItem key={type.ActionTypeID} value={type.ActionTypeID}>
                                      {type.ActionTypeName}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                              <Button sx={{ mt: 1 }} size="small" onClick={() => handleOpenActionTypeDialog('premium-new')}>
                                Add Action Type
                              </Button>
                            </Box>

                              <TextField
                                id="dueDateDats"
                                label="DueDate: Enter Days from Start Date"
                                type="number"
                                variant='outlined'
                                value={addActionDataPPlan.dueDays}
                                onChange={(e) => handleChangeNewActionPPlan('dueDays', e.target.value)}
                                sx={{  width:'320px', marginTop:'10px', marginLeft:'10px' }}
                              />
                              <TextField
                                id="sortOrder"
                                label="Sort Order"
                                type="number"
                                variant='outlined'
                                value={addActionDataPPlan.sortOrder}
                                onChange={(e) => handleChangeNewActionPPlan('sortOrder', e.target.value)}
                                sx={{  width:'130px', marginTop:'10px', marginLeft:'10px' }}
                              />




                            </Box>

               
                        
                      </DialogContent>
                      <DialogActions sx={{ marginRight:'20px' }}>
                      
                        <Button variant="outlined" color="error" onClick={handleNewActionDialogClose2}>Cancel</Button>
                        <Button variant="contained" color="success"  onClick={handleSubmitNewActionPPlan}>Save</Button>
                      </DialogActions>
                      
                    </Dialog>  


                  {/* DIALOG15 */}
                  {/* EDIT ACTION */}
                  {/* DIALOG15 */}


                  <Dialog  open={openEditAction2} onClose={handleEditActionDialogClose2} maxWidth="md" fullWidth>
                      <DialogTitle>EDIT PREMIUM ACTION
                      <MdOutlineLibraryAdd style={{ fontSize: '30px', float: 'right' }} />
                      </DialogTitle>
                      <br></br>
                      <DialogContent>
                     
                      <br></br>
                      <div sx={{display: 'flex',flexDirection: 'row'}}>
                           {/* Action Name */}
                        <TextField
                          autoFocus
                          margin="dense"
                          id="action-name"
                          label="Action Name"
                          type="text"
                          variant="outlined"
                          value={editActionDataPlan.actionName || ''}
                          onChange={(e) => handleChangeEditAction2('actionName', e)}  // 'e' is the event
                          sx={{  width:'620px' }}
                        />
                        </div>
                        <Box sx={{display: 'flex',flexDirection: 'row'}}>          
                        {/* Action Type Dropdown */}
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                          <FormControl  margin="dense" sx={{ marginLeft:'0px', width:'150px' }}>
                            <InputLabel id="action-type-label">Action Type</InputLabel>
                            <Select
                              labelId="action-type-label"
                              id="action-type-select"
                              value={editActionDataPlan.actionTypeID}
                              label="Action Type"
                              onChange={(e) => handleChangeEditAction2('actionTypeID', e.target.value)}
                            >
                               {actionTypeData.map((type) => (
                                <MenuItem key={type.ActionTypeID} value={type.ActionTypeID}>
                                  {type.ActionTypeName}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          <Button sx={{ mt: 1 }} size="small" onClick={() => handleOpenActionTypeDialog('premium-edit')}>
                            Add Action Type
                          </Button>
                        </Box>
                        <TextField
                                id="dueDateDats"
                                label="DueDate: Enter Days from Start Date"
                                type="number"
                                variant='outlined'
                                value={editActionDataPlan.dueDays}
                                onChange={(e) => handleChangeEditAction2('dueDays', e.target.value)}
                                sx={{  width:'320px', marginTop:'10px', marginLeft:'10px' }}
                              />
                              <TextField
                                id="sortOrder"
                                label="Sort Order"
                                type="number"
                                variant='outlined'
                                value={editActionDataPlan.sortOrder}
                                onChange={(e) => handleChangeEditAction2('sortOrder', e.target.value)}
                                sx={{  width:'130px', marginTop:'10px', marginLeft:'10px' }}
                              />

                      </Box>
                       
                      
                       
                      </DialogContent>
                      <DialogActions sx={{ marginRight:'20px' }}>
                      
                        <Button variant="outlined" color="error" onClick={handleEditActionDialogClose2}>Cancel</Button>
                        <Button variant="contained" color="success" onClick={handleEditActionSavePPlan}>Save</Button>
                      </DialogActions>
                      
                    </Dialog>


                  {/* DIALOG16 */}
                  {/* DELETE ACTION CONFIRMATION*/}
                  {/* DIALOG16 */}


                  <Dialog open={openDeleteAction2} onClose={handleDeleteActionDialogClose2} maxWidth="xs" fullWidth>
                      <DialogTitle>DELETE PREMIUM ACTION
                      <MdOutlineLibraryAdd style={{ fontSize: '30px', float: 'right' }} />
                      </DialogTitle>
                      <br></br>
                      <DialogContent>
                     
                      <br></br>
                     

                      <Typography 
                      sx={{
                        fontFamily: 'DM Serif Display, serif',
                        fontWeight: '400',
                        fontStyle: 'normal',
                        textAlign: 'center',
                        flexGrow: 1, // Allows the text to grow and push the icon to the right
                      }}
                      variant="h6"
                      gutterBottom
                    >
                     Are you sure?
                    </Typography>
                       
                      
                       
                      </DialogContent>
                      <DialogActions sx={{ marginRight:'20px' }}>
                      
                        <Button variant="outlined" color="error" onClick={handleDeleteActionDialogClose2}>Cancel</Button>
                      <Button variant="contained" color="success" onClick={handleDeleteActionSavePPlan}>Yes</Button>
                      </DialogActions>
                      
                    </Dialog>

                    <Dialog open={actionTypeDialogOpen} onClose={handleCloseActionTypeDialog} maxWidth="sm" fullWidth>
                      <DialogTitle>NEW ACTION TYPE</DialogTitle>
                      <DialogContent>
                        {newActionTypeFeedback.message ? (
                          <Alert severity={newActionTypeFeedback.severity || 'info'} sx={{ mt: 1, mb: 2 }}>
                            {newActionTypeFeedback.message}
                          </Alert>
                        ) : null}
                        <TextField
                          autoFocus
                          margin="dense"
                          id="new-action-type-name"
                          label="Action Type Name"
                          type="text"
                          fullWidth
                          variant="outlined"
                          value={newActionTypeName}
                          onChange={(e) => setNewActionTypeName(e.target.value)}
                        />
                      </DialogContent>
                      <DialogActions sx={{ marginRight:'20px' }}>
                        <Button variant="outlined" color="error" onClick={handleCloseActionTypeDialog}>Close</Button>
                        <Button variant="contained" color="success" onClick={handleCreateActionType}>Save</Button>
                      </DialogActions>
                    </Dialog>


                     {/* DIALOG17 */}
                  {/* DELETE MAIN ACTION CONFIRMATION*/}
                  {/* DIALOG16 */}


                  <Dialog className={`${styles[theme]}`}
                                      PaperProps={{
                                        className: theme === 'light' ? styles['light-dialogPaper'] : styles['dark-dialogPaper'],
                                      }} open={openDeleteAction3} onClose={handleDeleteActionDialogClose3} maxWidth="xs" fullWidth>
                      <DialogTitle>DELETE ACTION
                      <MdOutlineLibraryAdd style={{ fontSize: '30px', float: 'right' }} />
                      </DialogTitle>
                      <br></br>
                      <DialogContent>
                     
                      <br></br>
                     

                      <Typography 
                      sx={{
                        fontFamily: 'DM Serif Display, serif',
                        fontWeight: '400',
                        fontStyle: 'normal',
                        textAlign: 'center',
                        flexGrow: 1, // Allows the text to grow and push the icon to the right
                      }}
                      variant="h6"
                      gutterBottom
                    >
                     Are you sure?
                    </Typography>
                       
                      
                       
                      </DialogContent>
                      <DialogActions sx={{ marginRight:'20px' }}>
                      
                        <Button variant="contained" color="error" onClick={handleDeleteActionDialogClose3}>Cancel</Button>
                        <Button variant="contained" color="success" onClick={handleDeleteAction2}>Yes</Button>
                      </DialogActions>
                      
                    </Dialog>


            

      </aside>
      
  </>
  )
}

export default Actions
